export const CONVERSATION_ERROR_CODES: any = {
    "400": "Bad Request",
    "403": "Forbidden",
    "404": "Not Found",
    "410": "Unknown Error Code",
    "503": "Internal Error",
    "10001": "Account is not active",
    "10002": "Trial accounts do not support the feature you tried to use",
    "10003": "Incoming call rejected due to inactive account",
    "10004": "Call concurrency limit exceeded",
    "10005": "Voice calling has been disabled for this account",
    "11100": "Invalid URL format",
    "11200": "HTTP retrieval failure",
    "11201": "TCP connection timed out",
    "11202": "TCP connection refused",
    "11203": "HTTP communication total time out triggered",
    "11205": "HTTP connection failure",
    "11206": "HTTP protocol violation",
    "11210": "HTTP bad host name",
    "11215": "HTTP too many redirects",
    "11216": "HTTP invalid redirect",
    "11217": "HTTP error response code",
    "11220": "SSL/TLS Handshake Error",
    "11235": "Certificate Invalid - Domain Mismatch",
    "11236": "Certificate Invalid - Certificate Expired",
    "11237": "Certificate Invalid - Could not find path to certificate",
    "11240": "HTTP connection edge location is invalid",
    "11241": "HTTP connection edge location is not supported",
    "11242": "HTTP connection over Twilio Interconnect is not allowed",
    "11243": "HTTP retry policy is invalid",
    "11251": "Fatal protocol violation",
    "11300": "Invalid template URL",
    "11310": "Invalid template token",
    "11320": "Invalid template unclosed brackets",
    "11321": "Misconfigured webhook",
    "11322": "Invalid webhook method",
    "11750": "TwiML response body too large",
    "11751": "Media Message - Media exceeds messaging provider size limit",
    "11770": "Empty response body",
    "12100": "Document parse failure",
    "12101": "Invalid Twilio Markup XML version",
    "12102": "The root element must be Response",
    "12200": "Schema validation warning",
    "12300": "Invalid Content-Type",
    "12301": "Invalid Upload Content-Type",
    "12400": "Internal Failure",
    "13000": "Conference Noun cannot be mixed with Number nouns",
    "13110": "Annotate: Annotate must contain one valid nested element",
    "13111": "Annotate: Annotate must contain only one of element X",
    "13112": "Annotate: Invalid nested element",
    "13120": "Annotate->BillingReferenceTag cannot be over 128 characters",
    "13201": "Dial: Cannot Dial out from a Dial Call Segment",
    "13210": "Dial: Invalid method value",
    "13211": "Dial: Invalid ifMachine value",
    "13212": "Dial: Invalid timeout value",
    "13213": "Dial: Invalid hangupOnStar value",
    "13214": "Dial: Invalid callerId value",
    "13215": "Dial: Invalid nested element",
    "13216": "Invalid timeLimit value",
    "13217": "Dial: Invalid record value",
    "13218": "Dial: Invalid sequential value",
    "13219": "Dial: Invalid answerOnBridge value",
    "13220": "Dial: Invalid ringTone value",
    "13221": "Dial->Number: Invalid method value",
    "13222": "Dial->Number: Invalid sendDigits value",
    "13223": "Dial: Invalid phone number format",
    "13224": "Dial: Twilio does not support calling this number or the number is invalid",
    "13225": "Dial: Call blocked by Twilio",
    "13226": "Dial: Invalid country code",
    "13227": "Geo Permission configuration is not permitting call",
    "13230": "Dial->Conference: Invalid muted value",
    "13231": "Dial->Conference: Invalid endConferenceOnExit value",
    "13232": "Dial->Conference: Invalid startConferenceOnEnter value",
    "13233": "Dial->Conference: Invalid waitUrl",
    "13234": "Dial->Conference: Invalid waitMethod",
    "13235": "Dial->Conference: Invalid beep value",
    "13236": "Dial->Conference: Invalid Conference Sid",
    "13237": "Dial->Conference: Invalid Conference Name",
    "13238": "Dial->Conference: Invalid Verb used in waitUrl, holdUrl, or announceUrl TwiML",
    "13239": "Dial->Conference: Invalid Trim Value",
    "13240": "Dial->Conference: Invalid Whisper SID",
    "13241": "Dial->SIP: Invalid method value",
    "13242": "Dial->SIP: Invalid sendDigits value",
    "13243": "Dial->SIP: Invalid SIP URI",
    "13244": "Dial: No SIP Authorization",
    "13245": "Dial: Not allowed in this API version",
    "13246": "Dial: SIP dialing not enabled for this account",
    "13247": "Dial: Invalid From number (caller ID)",
    "13248": "Dial: Invalid callerID, too long",
    "13249": "Dial: Invalid username or password attribute",
    "13250": "Dial: Too many URIs passed",
    "13251": "Dial: Too many headers passed",
    "13252": "Dial: Invalid header name",
    "13253": "Dial: Header is too long",
    "13254": "Dial->Sip: SIP URI DNS does not resolve or resolves to an non-public IP address",
    "13255": "Dialing .sip.twilio.com addresses is not currently allowed",
    "13256": "Invalid recordingStatusCallback URL",
    "13257": "Invalid transcribeCallback URL",
    "13258": "Dial->Sim not supported in this realm",
    "13299": "2010 Conference API feature requested using 2008 API",
    "13310": "Gather: Invalid finishOnKey value",
    "13311": "Gather: Invalid finishOnKey value",
    "13312": "Gather: Invalid method value",
    "13313": "Gather: Invalid timeout value",
    "13314": "Gather: Invalid numDigits value",
    "13320": "Gather: Invalid nested verb",
    "13321": "Gather -> Say: Invalid voice value",
    "13322": "Gather->Say: Invalid loop value",
    "13325": "Gather->Play: Invalid Content-Type",
    "13326": "Gather: Invalid input value",
    "13327": "Gather: Invalid speechTimeout value",
    "13328": "Gather: Invalid maxSpeechTime value",
    "13329": "Gather: Invalid partialResultCallbackMethod value",
    "13330": "Gather: Invalid hints value",
    "13331": "Gather: Invalid language value",
    "13332": "Gather: Invalid bargeIn value",
    "13333": "Gather: Invalid profanityFilter value",
    "13334": "Gather: Invalid model value",
    "13335": "Gather: speechTimeout auto cannot be used with model default",
    "13337": "Gather: callback must be over HTTPS when using gather with PCI compliance",
    "13338": "Gather: Invalid actionOnEmptyResult value",
    "13340": "Gather: Degraded Speech ",
    "13342": "Gather: Invalid config for Google STT V2 provider",
    "13410": "Play: Invalid loop value",
    "13420": "Play: Invalid Content-Type",
    "13430": "Play: Invalid DTMF String",
    "13510": "Say: Invalid loop value",
    "13511": "Say: Invalid voice value",
    "13512": "Gather element has an invalid \"language\" attribute value",
    "13513": "Say: Invalid rate value",
    "13520": "Say: Invalid text",
    "13521": "`<Say>` element character limits exceeded",
    "13610": "Record: Invalid method value",
    "13611": "Record: Invalid timeout value",
    "13612": "Record: Invalid maxLength value",
    "13613": "Record: Invalid finishOnKey value",
    "13614": "Record: Invalid transcribe value",
    "13615": "Record: maxLength too high for transcription",
    "13616": "Record: playBeep must be true or false",
    "13617": "Record: Recording length is out of range for transcription",
    "13618": "Record: Recording not available for transcription",
    "13619": "Record: Transcription feature not available for this type of recording.",
    "13620": "Record: Transcription not available for this recording",
    "13621": "Invalid 'recordingStatusCallbackEvent'",
    "13622": "Record: invalid recordingTrack value",
    "13699": "Record: Invalid trim value",
    "13710": "Redirect: Invalid method value",
    "13750": "Twiml verb not supported by this API version.",
    "13801": "Refer not allowed on non-SIP call legs",
    "13802": "Dial: No referUrl attribute specified",
    "13803": "SMS verb not supported in this realm",
    "13804": "AddOns are not supported in this realm",
    "13805": "Trial account call duration exceeded 10 minute limit",
    "13810": "Reject: Invalid cause",
    "13910": "Pause: Invalid length value",
    "14101": "Invalid \"To\" attribute",
    "14102": "Invalid \"From\" attribute",
    "14103": "Invalid Body",
    "14104": "Invalid Method attribute",
    "14105": "Invalid statusCallback attribute",
    "14106": "Document retrieval limit reached",
    "14107": "SMS send rate limit exceeded",
    "14108": "From phone number not SMS capable",
    "14109": "TwiML Reply message limit exceeded",
    "14110": "Invalid Verb for SMS Reply",
    "14111": "Invalid To phone number for Trial mode",
    "14201": "Enqueue: Invalid method value",
    "14202": "Enqueue: Invalid waitUrl",
    "14203": "Enqueue: Invalid Enqueue action url",
    "14204": "Enqueue: Queue name too short",
    "14205": "Enqueue: Queue name too long",
    "14206": "Enqueue: Invalid waitUrlMethod value",
    "14207": " Enqueue: The targeted queue reached max queue size",
    "14210": "Dial->Queue: Invalid whisper method",
    "14211": "Dial->Queue: Invalid whisper url",
    "14212": "Dial->Queue: queue name too short",
    "14213": "Dial->Queue: queue name too long",
    "14215": "Dial->Queue: Invalid ReservationSid. Unable to dequeue",
    "14217": "Dial->Queue: Could not find or accept provided reservationSid",
    "14218": "Dial->Queue: Could not update worker to provided activity",
    "14219": "TaskRouter Dial Queue not supported in this realm",
    "14220": "Enqueue: Provided Workflow was not a valid sid",
    "14221": "Enqueue: Provided Attributes JSON was not valid",
    "14222": "Enqueue: Could not create Task",
    "14223": "Enqueue: Unable to cleanup task",
    "14226": "TaskRouter Enqueue not supported in this realm",
    "14230": "Dial->Conference: Invalid WorkflowSid",
    "14231": "Dial->Conference: Provided Attributes was not valid JSON ",
    "14232": "Dial->Conference: Invalid Priority",
    "14233": "Dial->Conference: Invalid Timeout",
    "14234": "Dial->Conference: Unable to create task",
    "14235": "Dial->Conference: Unable to cleanup task",
    "14236": "Dial->Conference: Invalid ReservationSid",
    "14237": "Dial->Conference: Invalid PostWorkActivitySid",
    "14238": "Dial->Conference: Unable to accept Reservation",
    "14239": "Dial->Conference: Unable to update Worker",
    "14240": "Max concurrent Workers exceeded",
    "14241": "start_date passed to TaskRouter statistics is older than 30 days.",
    "14300": "Start: Invalid nested noun value",
    "15000": "Call Progress: Internal Twilio Error",
    "15002": "Call Progress: Queue Timeout",
    "15003": "Call Progress: Warning Response to Callback URL",
    "15004": "Action Callback URL must be an absolute URL when using TwiML to update in-progress calls",
    "15009": "Internal Server Error",
    "16000": "Whisper Not Available on Twilio Conference",
    "16001": "Conference is not bridged",
    "16002": "Failed to validate conference attributes",
    "16003": "Could not recognize conference sid or friendly name",
    "16010": "Conference Event: Internal Twilio Error",
    "16011": "Conference Event: Error Response to Callback URL",
    "16020": "Conference is full",
    "16021": "Failed to join conference due to account concurrency limit exceeded",
    "16022": "Conference does not exist or is completed",
    "16023": "Dial->Conference: Invalid participant label, must not exceed 128 characters, must not be a CallSid, must not contain '/'",
    "16024": "Invalid participant label, must not exceed 128 characters, must not be a CallSid, must not contain '/'",
    "16025": "Dial->Conference: Participant label is in use by another participant",
    "16026": "Participant label is in use by another participant",
    "16027": "Participant to be whispered is on hold",
    "16028": "Participant to be whispered is not present in the conference",
    "16030": "Participant failed to be added to the conference",
    "16099": "Unexpected conference status",
    "16101": "Voice Recording : Unavailable because duration is too short",
    "16102": "Voice Recording: Unavailable because recording is silent",
    "16104": "Voice Recording: Unavailable due to encryption failure",
    "16105": "Voice Recording: Unavailable due to no valid public keys",
    "16106": "Voice Recording: Unavailable due to internal encryption error",
    "16107": "Voice Recording: Encrypted with alternate public key",
    "16108": "Voice Recording: Request failed due to concurrent recordings",
    "16109": "Voice Recording: Cannot fetch .mp3 encrypted recording",
    "16110": "Internal failure when bulk deleting recordings from your account",
    "16111": "Voice Recording: Upload file to external AWS S3 bucket failed (Invalid Configuration)",
    "16112": "Voice Recording: Upload file to external AWS S3 bucket failed (Access Denied)",
    "16113": "Voice Recording: Cannot download a dual-channel presentation of a mono recording",
    "17000": "Forbidden to access data",
    "17001": "Completed summary for this call wasn't found",
    "17002": "This call ended more than 30 days ago",
    "17007": "Voice Insights Advanced Features not enabled",
    "17008": "Internal Server Error - Query Timeout",
    "17009": "Internal Server Error",
    "17400": "Invalid query parameter",
    "18001": "Invalid document submission",
    "18002": "Illegible or blurry document submission",
    "18003": "Expired or invalid document submission",
    "18004": "Redactions in document.",
    "18005": "Missing information",
    "18006": "Information does not match the supporting document",
    "18007": "Incomplete document submission.",
    "18008": "Name mismatch (Proof of Identity)",
    "18009": "Nationality mismatch (Proof of Identity)",
    "18010": "Business registration number mismatch.",
    "18011": "Business name mismatch",
    "18012": "Require domestic address.",
    "18013": "Require domestic emergency address.",
    "18014": "Invalid or incomplete address provided.",
    "18015": "Invalid or incomplete emergency address provided.",
    "18016": "Address mismatch.",
    "18017": "Address not found",
    "18018": "PO Box not allowed.",
    "18019": "Proof of Identity Required for Authorized Representative.",
    "18020": "Proof of authorized representative’s association with the business required.",
    "18021": "Name mismatch (Proof of Address)",
    "18022": "Outdated Proof of Address document",
    "18023": "Document contains an inactive business",
    "18024": "Failed to upload an unprocessable document",
    "18036": "One or more of the required information is missing.",
    "18037": "Missing information in the form",
    "18038": "Information does not match the supporting document",
    "18039": "The phone number type you selected requires a valid domestic address.",
    "18050": "Issue with the Supporting Document(s)",
    "18051": "Issue with the inputs you provided",
    "18052": "Under age Individual",
    "18053": "Unable to verify association between business name and website",
    "18054": "Invalid phone number",
    "18055": "Invalid email",
    "18056": "Missing Work Email for Authorized Representative",
    "18057": "Validation Issue for Authorized Representative",
    "18058": "Missing Tax ID",
    "18059": "Missing/Invalid Photo ID",
    "18060": "Commercial registration copy not submitted",
    "18061": "Invalid excerpt from the commercial register",
    "18062": "Business Details contain an inactive business",
    "18099": "Rejected test bundle",
    "18601": "The association between business name and website cannot be verified",
    "18602": "The Business ID you provided could not be verified",
    "18603": "The address could not be verified",
    "18604": "Unable to verify Authorized representative #1",
    "18605": "Unable to verify Authorized representative #2. ",
    "18606": "The Email domain doesn't match the website domain",
    "18607": "Customer Profile or Trust Product is not eligible to be copied",
    "18608": "Customer Profile or Trust Product is already copied",
    "18609": "Ineligible Business Registration Authority",
    "18610": "Customer Profile or Trust Product cannot be copied due to a deleted Address",
    "19003": "Contact with the unique_customer_provided_id provided already exists",
    "19004": "Invalid or missing Contact input",
    "19005": "Contact validation error",
    "19010": "Invalid contact search request",
    "19011": "When updating a contact, invalid JSON syntax or invalid field that cannot be updated by this endpoint",
    "19012": "When updating a contact at least one field should be updated",
    "19013": "At least one of the following fields is required for a contact: first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or channel",
    "19014": "Can fetch contact either by unique_customer_provided_id or channel ",
    "19020": "Contact with the provided channel value already exists",
    "19021": "Only one channel can be set as primary",
    "19022": "Invalid channel",
    "19023": "Invalid channel type",
    "19024": "Invalid channel input",
    "19025": "Channel validation error",
    "19026": "Maximum number of channels allowed reached",
    "19027": "Invalid Channel Description",
    "19028": "Channel value can not be updated",
    "19029": "When updating a channel at least one field should be updated",
    "19030": "Invalid location type",
    "19031": "Maximum number of locations allowed reached ",
    "19032": "Invalid location input",
    "19033": "Location validation error",
    "19034": "Invalid country code",
    "19035": "Invalid page size, it must be between 1 and 25 if specified",
    "19036": "Invalid page token",
    "19037": "When updating a location at least one field should be updated",
    "19038": "Page token must be bigger than or equal to 0",
    "19040": "Custom Field provided is not defined",
    "19041": "Invalid or missing Custom Field input",
    "19042": "Custom Field validation error",
    "19043": "Field definition name already exists",
    "19044": "Field definition name exceeded maximum length",
    "19045": "Field definition type is invalid; data types that are supported are text, date, and number",
    "19046": "Number of custom field definitions exceeded limit",
    "19047": "Field definition name cannot be empty",
    "19048": "Input request body is not properly json formatted",
    "19049": "Custom field definition provided is not defined",
    "19050": "Internal Server Error",
    "19052": "Invalid page size for custom field definition",
    "19053": "Field definition name cannot be a duplicate of an existing Twilio-defined field",
    "19054": "Expected Unique form key in input request is missing",
    "19055": "When updating a channel, invalid JSON syntax or invalid field that cannot be updated by this endpoint",
    "19056": "Input request content type is invalid",
    "19057": "Server unavailable or busy",
    "20001": "Unknown parameters",
    "20002": "Invalid FriendlyName",
    "20003": "Permission Denied",
    "20004": "Method not allowed",
    "20005": "Account not active",
    "20006": "Access Denied",
    "20007": "Page size too large",
    "20008": "Test Credentials",
    "20009": "Cannot delete this resource before it is complete",
    "20010": "Action disabled for account",
    "20011": "Invalid TLS version",
    "20012": "Invalid TLSv1.2 Cipher Suite",
    "20020": "No update/state change is observed for the data entered",
    "20021": "Phone number rejected by T-Mobile SDG Service Provisioning API",
    "20023": "Phone number is not correct: it cannot be null or have non-decimal symbols",
    "20101": "Invalid Access Token",
    "20102": "Invalid Access Token header",
    "20103": "Invalid Access Token issuer/subject",
    "20104": "Access Token expired or expiration date invalid",
    "20105": "Access Token not yet valid",
    "20106": "Invalid Access Token grants",
    "20107": "Invalid Access Token signature",
    "20151": "Authentication Failed",
    "20152": "Invalid Header",
    "20153": "Invalid Issuer Or Subject",
    "20154": "Invalid Claim Set",
    "20155": "Expiration Time In The Future",
    "20156": "Expired or Invalid Expiration in Token",
    "20157": "Expiration Time Exceeds Maximum Time Allowed",
    "20159": "Invalid Signature",
    "20160": "Invalid Token",
    "20161": "Programmable Chat: Parameters are not specified for update request",
    "20162": "A conflicting resource update is in progress",
    "20403": "403 Forbidden",
    "20404": "Not Found",
    "20409": "Conflict",
    "20410": "Gone",
    "20413": "Request Entity Too Large",
    "20422": "Invalid Parameter",
    "20423": "Invalid SID",
    "20426": "Upgrade Required",
    "20429": "Too Many Requests",
    "20500": "Internal Server Error",
    "20503": "Service unavailable",
    "20504": "Twilio Internal Error",
    "21100": "Accounts Resource",
    "21101": "Subaccounts cannot contain subaccounts",
    "21102": "Reached maximum number of Services",
    "21200": "Calls Resource",
    "21201": "No Called number specified",
    "21202": "Called number is a premium number",
    "21203": "International calling not enabled",
    "21204": "Call already initiated",
    "21205": "Invalid URL",
    "21206": "Invalid SendDigits",
    "21207": "Invalid IfMachine",
    "21208": "Invalid Timeout",
    "21209": "Invalid Method",
    "21210": "'From' phone number not verified",
    "21211": "Invalid 'To' Phone Number",
    "21212": "Invalid 'From' Number",
    "21213": "Caller phone number is required",
    "21214": "'To' phone number cannot be reached",
    "21215": "Geo Permission configuration is not permitting call",
    "21216": "API: Call blocked by Twilio",
    "21217": "Phone number does not appear to be valid",
    "21218": "Invalid ApplicationSid",
    "21219": "'To' phone number not verified",
    "21220": "Invalid call state",
    "21221": "Invalid SipAuthUsername. Must be fewer than 256 chars",
    "21222": "Invalid SipAuthUsername. Illegal chars",
    "21223": "Invalid SipAuthPassword. Must be fewer than 256 chars",
    "21224": "Invalid SipAuthPassword. Illegal chars",
    "21225": "SipAuthPassword is required when providing SipAuthUsername",
    "21226": "SIP calling not enabled for this account",
    "21227": "Headers portion of SIP URI must be fewer than 1024 chars",
    "21228": "Invalid SIP Header. Illegal chars in header name",
    "21229": "Invalid SIP Header. Illegal chars in header value",
    "21230": "Maximum Domains Reached",
    "21231": "Domain Validation Error",
    "21232": "Invalid Domain",
    "21233": "Domain still has subdomains",
    "21234": "Invalid Machine Detection configuration value",
    "21235": "IP Access Control List Validation Error",
    "21236": "IP Access Control List Dependencies Violation",
    "21237": "Maximum IP Addresses Reached for List",
    "21238": "Address Validation Error",
    "21239": "Maximum Credential Lists Reached",
    "21240": "Credential List Validation Error",
    "21241": "Credential List Dependencies Violation",
    "21242": "Maximum Credentials Reached for List",
    "21243": "Credential Validation Error",
    "21244": "Maximum Number of Trunks reached",
    "21245": "Trunk Validation Error",
    "21247": "Trunk Dependencies",
    "21248": "Trunk Domain already taken",
    "21249": "Maximum Origination URIs reached  ",
    "21251": "Trunking CPS change not allowed",
    "21252": "Invalid Region",
    "21253": "Max Connection Policies Reached",
    "21254": "Max Connection Policy Entries Reached",
    "21255": "Maximum IP Access Control Lists reached",
    "21256": "Invalid ruleset",
    "21257": "Invalid SIP Manipulation Policy SID",
    "21258": "Invalid SIP Manipulation Policy",
    "21259": "Maximum number of SIP Manipulation Polies per account reached",
    "21260": "Maximum number of actions per rule reached",
    "21261": "Maximum number of conditions per rule reached",
    "21262": "No AMD status callback URL provided",
    "21263": "Invalid Answering Machine Detection Parameters",
    "21264": "‘From’ phone number not verified",
    "21265": "'To' number cannot be a Short Code",
    "21266": "'To' and 'From' numbers cannot be the same",
    "21267": "Alphanumeric Sender ID cannot be used as the 'From' number on trial accounts",
    "21268": "Sending to Premium rate or Information Service numbers is not allowed",
    "21300": "Invalid BYOC trunk SID",
    "21301": "Cannot create application: application limit exceeded",
    "21302": "Approaching application creation limit ",
    "21401": "Invalid Phone Number",
    "21402": "Invalid Url",
    "21403": "Invalid Method",
    "21404": "Inbound Phone number not available to trial account",
    "21405": "Cannot set VoiceFallbackUrl without setting Url",
    "21406": "Cannot set SmsFallbackUrl without setting SmsUrl",
    "21407": "This Phone Number type does not support SMS",
    "21408": "Permission to send an SMS or MMS has not been enabled for the region indicated by the 'To' number",
    "21409": "VoiceCallerIdLookup cannot be set for this phone number",
    "21420": "ApplicationSid is not accessible",
    "21421": "Phone Number is invalid",
    "21422": "PhoneNumber is not available",
    "21449": "Number already can be used for outgoing calls and messages",
    "21450": "Phone number already validated on your account",
    "21451": "Invalid area code",
    "21452": "No phone numbers found in area code",
    "21453": "Phone number already validated on another account",
    "21454": "Invalid CallDelay",
    "21455": "Invalid PlayUrl",
    "21456": "Invalid CallbackUrl",
    "21457": "AreaCode Parameter not Supported",
    "21458": "PhoneNumber Provisioning Type Mismatch",
    "21470": "Invalid AccountSid",
    "21471": "Account does not exist",
    "21472": "Account is not active",
    "21473": "AccountSid you are transferring to is not related to the originating owner of the phone number",
    "21474": "API User must be the parent account to transfer phone numbers.",
    "21475": "Unable to update Status, invalid Status.",
    "21476": "Unable to update Status for subaccount, parent account is suspended.",
    "21477": "Unable to update Status for parent accounts",
    "21478": "Unable to update Status for subaccount, subaccount has been suspended by Twilio",
    "21479": "Unable to update Status for subaccount, subaccount has been closed.",
    "21480": "Reached maximum number of subaccounts",
    "21481": "Invalid PageToken",
    "21501": "Resource not available",
    "21502": "Invalid callback url",
    "21503": "Invalid transcription type",
    "21504": "RecordingSid is required.",
    "21601": "Phone number is not a valid SMS-capable inbound phone number",
    "21602": "Message body is required",
    "21603": "A 'From' or 'MessagingServiceSid' parameter is required to send a message",
    "21604": "The destination 'To' phone number is required to send an SMS",
    "21605": "Maximum body length is 160 characters (old API endpoint)",
    "21606": "The 'From' phone number provided is not a valid message-capable Twilio phone number for this destination/account",
    "21607": "The 'from' phone number must be the sandbox phone number for trial accounts.",
    "21608": "The 'to' phone number provided is not yet verified for this account.",
    "21609": "Invalid 'StatusCallback'",
    "21610": "Attempt to send to unsubscribed recipient",
    "21611": "This 'From' number has exceeded the maximum number of queued messages",
    "21612": "Message cannot be sent with the current combination of \"To\" and/or \"From\" parameters",
    "21613": "PhoneNumber Requires Certification",
    "21614": "'To' number is not a valid mobile number",
    "21615": "Phone Number Requires a Local Address",
    "21616": "The 'From' number matches multiple numbers for your account",
    "21617": "The concatenated message body exceeds the 1600 character limit",
    "21618": "The message body cannot be sent",
    "21619": "A Message Body, Media URL or Content SID is required",
    "21620": "Invalid media URL(s)",
    "21621": "The 'From' number has not been enabled for MMS",
    "21622": "MMS has not been enabled for your account",
    "21623": "Number of media files exceeds allowed limit",
    "21624": "Invalid validity period value",
    "21626": "Invalid 'StatusCallbackEvent'",
    "21627": "Max Price must be a valid float",
    "21628": "Address Validation Error",
    "21629": "Address Validation Error - Check Suggested Address",
    "21630": "Cannot mutate Address that is linked to a verified Document.",
    "21631": "Phone Number Requires an Address",
    "21634": "SIP Trunk is in use for emergency calling",
    "21635": "'To' number cannot be a landline",
    "21644": "End-User cannot be deleted due to an active assignment to a Bundle",
    "21645": "Supporting Document cannot be deleted due to active Regulatory Bundle assignment",
    "21646": "Supporting Document is not eligible for deletion",
    "21647": "Regulatory Bundle is not eligible for deletion",
    "21648": "Regulatory Bundle cannot be deleted due to active number assignment",
    "21649": "Phone Number Requires a Bundle",
    "21650": "Phone Number Requires a Verified Identity Document",
    "21651": "Document does not satisfy regulatory requirement",
    "21652": "Maximum subject length is 40 characters",
    "21653": "There are more recipient addresses than allowed",
    "21654": "ContentSid Required",
    "21655": "The ContentSid is Invalid",
    "21656": "The ContentVariables Parameter is invalid",
    "21657": "The Sender ID is invalid ",
    "21658": "Parameter exceeded character limit",
    "21659": "'From' is not a Twilio phone number or Short Code country mismatch",
    "21660": "Mismatch between the 'From' number and the account",
    "21661": "'From' number is not SMS-capable",
    "21701": "The Messaging Service does not exist",
    "21702": "The Messaging Service is not available to send new messages",
    "21703": "The Messaging Service does not have a phone number available to send a message",
    "21704": "The Messaging Service contains no phone numbers",
    "21705": "The Messaging Service is invalid",
    "21708": "Alpha Sender ID Missing from the request",
    "21709": "Alpha Sender ID is Invalid or Not Authorized for this Messaging Service",
    "21710": "Phone Number Already Exists in Messaging Service",
    "21711": "Phone Number, Shortcode, Destination AlphaSender, and Global AlphaSender is not associated to the specified Messaging Service.",
    "21712": "Phone Number or Short Code is associated with another Messaging Service.",
    "21713": "Messaging Service Use Case is Invalid",
    "21714": "Messaging Service Number Pool size limit reached",
    "21715": "Phone Number Does Not Have Correct Messaging Service Capabilities",
    "21717": "Brand Registration SID for US A2P Campaign Use Case is Not Registered or Not Valid",
    "21719": "Incompatible Messaging Service/A2P Use Cases",
    "21720": "A2P Use Case is Invalid",
    "21721": "Cannot import Campaign Verify token due to incompatible A2P brand",
    "21722": "Invalid Campaign Verify token",
    "21723": "Campaign Verify token import already in progress",
    "21724": "Brand update count exceeded",
    "21725": "Brand can only be updated when in FAILED state",
    "21726": "Starter brand registrations and updates are temporarily disabled",
    "21727": "Campaign registration failed due to missing parameter(s)",
    "21728": "Campaign registration failed due to length validation failures",
    "21729": "Cannot perform operation on suspended campaign",
    "21730": "System under maintenance. Please try again later.",
    "21731": "Cannot perform operation on suspended brand",
    "21732": "Campaign limit reached on the Brand",
    "21733": "Default Messaging Service Not Found",
    "21736": "Brand 2FA Failed",
    "21737": "Campaign Registration Blocked for Non-Compliant Brand",
    "21900": "DltPEId is invalid",
    "21901": "DltTemplateId is invalid",
    "21902": "InvoiceTag length must be between 0 and 32",
    "21910": "Invalid 'From' and 'To' pair. 'From' and 'To' should be of the same channel",
    "22001": "Call timed out",
    "22005": "Call Queue Full",
    "22100": "Reached Maximum Verification Attempts",
    "22101": "Invalid Hosted Number Order SIDs",
    "22102": "Invalid Phone Number",
    "22103": "Unsupported Iso Country",
    "22104": "Invalid Email Format",
    "22105": "Invalid URL format",
    "22106": "Invalid Method",
    "22107": "Unable to Update Authorization Document",
    "22108": "Invalid Application SID",
    "22109": "Invalid Address SID",
    "22110": "Phone Number Not Hostable",
    "22111": "Invalid Hosted Number Order Status",
    "22112": "Unable to Update Hosted Number Order Status",
    "22113": "Phone Verification Incorrect",
    "22114": "Unable to Verify Code",
    "22115": "Invalid Unique Name",
    "22116": "Invalid Friendly Name",
    "22117": "Invalid Extension",
    "22118": "Invalid Verification Document SID",
    "22119": "Invalid Capabilities",
    "22120": "Invalid Verification Type",
    "22121": "Unable to Transfer Hosted Number",
    "22122": "Invalid Authorization Document Status",
    "22123": "Unable to Initiate Verification Call",
    "22130": "Not Portable - Unsupported",
    "22131": "Not Portable - Already in your Twilio Account",
    "22132": "Not Portable - Already in Twilio different owner",
    "22133": "Not Portable API - Manual porting available",
    "22135": "Error - Internal Server Error",
    "22136": "Not Portable - Already in one of your Twilio Accounts",
    "22150": "Port In Error - Contact support required",
    "22151": "Port In Error - Number with carrier restrictions",
    "22152": "Port In Error - Phone number is inactive or disconnected",
    "22153": "Port In Error - Invalid end user name",
    "22154": "Port In Error - Invalid Address",
    "22155": "Port In Error - Invalid Pin",
    "22156": "Port In Error - Invalid Account Number",
    "22157": "Port In Error - Invalid Subscription Right",
    "22158": "Port In Error - Port Date Rejected",
    "22159": "Port In Error - Not Portable",
    "22170": "Port In Error - Invalid Bundle",
    "22171": "Port In Error - Missing required fields",
    "22172": "Port In Error - Contains numbers for multiple countries",
    "22173": "Port In Error - Invalid Address",
    "22199": "Configuration Retrieval Error",
    "22200": "Invalid End-User Type or Number Type",
    "22201": "No regulation sid found for the given number group",
    "22202": "No regulation sid or phone number country and type was provided",
    "22203": "Unable to parse bundle status",
    "22204": "Bundle status and properties cannot be updated in the same request",
    "22205": "Attempting to assign invalid object_sid to Bundle",
    "22206": "Attempting to add invalid object type to bundle",
    "22207": "Unable to parse attributes JSON",
    "22208": "Supporting Document status and attributes cannot be updated in the same request",
    "22209": "Invalid status enum in Supporting Document update request",
    "22210": "Cannot create a Supporting Document with no Type",
    "22211": "Cannot create a Supporting Document with no FriendlyName",
    "22212": "Invalid End-User Type in request",
    "22213": "Invalid Number Type in request",
    "22214": "Missing End User",
    "22215": "Missing End-User field",
    "22216": "Missing Supporting Document",
    "22217": "Missing Supporting Document field",
    "22218": "The Supporting Document field does not match the field in the End-User",
    "22219": "An Address is missing",
    "22221": "Emergency address is not registered",
    "22222": "Emergency Status cannot be updated",
    "22223": "Regulatory Bundle is not eligible to be Copied",
    "22224": "Regulatory Bundle cannot transfer Item Assignments",
    "22225": "From Bundle to Replace Items does not exist",
    "22226": "Cannot replace Items from Bundle to same Bundle",
    "22228": "From Bundle does not have latest Regulation requirements that matches destination Bundle",
    "22229": "Supporting Document Bundle Assignment cannot be removed",
    "22230": "Regulatory Bundle cannot be copied due to a deleted Address",
    "22300": "This account is restricted from provisioning new long code phone numbers",
    "22350": "The Phone Number cannot be released because it is being ported out of Twilio",
    "22400": "Phone Number linked to Active Route Configuration",
    "22401": "Phone Number Instance fields are not supported within region",
    "22402": "Phone Number Operation not permitted within Region",
    "22403": "Phone Number Operation not permitted within Region",
    "22404": "Starter profile creation and updates are temporarily disabled",
    "22500": "Twilio phone number using deprecated API version",
    "23001": "Message Redaction Incompatible Configuration: Long code STOP filtering",
    "23002": "Message Redaction Incompatible Configuration: Short code \"STOP\" filtering",
    "23003": "Message Redaction Incompatible Configuration: Sticky Sender",
    "23004": "Message Redaction Incompatible Configuration: Advanced Opt-Out",
    "23005": "Phone Number Redaction Incompatible Configuration: Fallback to Long Code",
    "23006": "Message Redaction Incompatible Configuration: Inbound Webhook GET Requests",
    "25001": "The specified filter for listing organization users is invalid",
    "25002": "The provided user's first name is invalid",
    "25003": "The provided user's last name is invalid",
    "25004": "The provided user's external ID is invalid",
    "25005": "The provided user's username is invalid",
    "25006": "The SCIM schema syntax is invalid",
    "25007": "The organization has reached its limit for managed users",
    "25008": "The requested SCIM user was not found",
    "25009": "The user's is in an unupdatable status.",
    "25010": "The primary email address is missing for the user",
    "25011": "The value for the primary email address is invalid",
    "25012": "Updating the email address is unsupported",
    "25013": "Updating the username is unsupported",
    "25014": "The primary email address does not match the username",
    "25015": "The SCIM PATCH request is invalid",
    "25016": "Updating the organization owner is not allowed",
    "25017": "The email domain is unverified",
    "25018": "The request is not authorized",
    "25019": "Failed to complete request due to a business rule violations",
    "25020": "Version conflict in SCIM header",
    "25021": "Rate limit exceeded",
    "25022": "Duplicate username or externalId",
    "25023": "Invalid page token",
    "25100": "The organization was not found",
    "25101": "The organization's account was not found",
    "25102": "The organization's account limit has been reached",
    "25103": "The organization's account owner is not a managed user",
    "25104": "The organization's account owner was not set during creation",
    "25105": "The request is not authorized",
    "25106": "Failed to complete request due to a bad request",
    "25107": "The Request does not contain any authorization information",
    "25109": "Request is rate limited",
    "25200": "The scope for role assignments must be a managed account",
    "25201": "The identity for role assignments must be a managed user",
    "25202": "The role assignment has an invalid role",
    "25203": "Listing role assignments requires query parameters",
    "30001": "Queue overflow",
    "30002": "Account suspended",
    "30003": "Unreachable destination handset",
    "30004": "Message blocked",
    "30005": "Unknown destination handset",
    "30006": "Landline or unreachable carrier",
    "30007": "Message filtered",
    "30008": "Unknown error",
    "30009": "Missing inbound segment",
    "30010": "Message price exceeds max price",
    "30011": "MMS not supported by the receiving phone number in this region",
    "30012": "TTL is too small",
    "30013": "TTL is too big",
    "30014": "'To' attributes are Invalid",
    "30015": "Non-supported channel type is used",
    "30016": "'To' and 'From' channel types are incompatible",
    "30017": "Carrier network congestion",
    "30018": "Destination carrier requires sender ID pre-registration",
    "30019": "Content size exceeds carrier limit",
    "30020": "Internal Failure with Message Scheduling",
    "30021": "Internal Failure with messaging service orchestrator",
    "30022": "US A2P 10DLC - Rate Limits Exceeded",
    "30023": "US A2P 10DLC - Daily Message Cap Reached",
    "30024": "Numeric Sender ID Not Provisioned on Carrier",
    "30025": "US A2P 10DLC - 50% T-Mobile Daily Message Limit Consumed",
    "30026": "US A2P 10DLC - 70% T-Mobile Daily Message Limit Consumed",
    "30027": "US A2P 10DLC - T-Mobile Daily Message Limit Reached",
    "30028": "Invalid API version",
    "30029": "Invalid ContentRetention",
    "30030": "Invalid AddressRetention",
    "30031": "Invalid MaxRate",
    "30032": "Toll-Free Number Has Not Been Verified",
    "30033": "US A2P 10DLC - Campaign Suspended",
    "30034": "US A2P 10DLC - Message from an Unregistered Number",
    "30035": "US A2P 10DLC - Message from a number still being configured",
    "30036": "Validity Period Expired",
    "30037": "Outbound Messaging Disabled",
    "30038": "OTP Message Body Filtered",
    "30039": "Filtered to Prevent Message Loops",
    "30040": "Destination carrier requires Sender ID pre-registration",
    "30041": "Message from an unregistered number sent to a United Kingdom number",
    "30042": "The Sender ID is blocked as generic or it contains special characters",
    "30043": "International SMS via Domestic Gateway",
    "30044": "Trial Message Length Exceeded",
    "30100": "Domain SID is invalid",
    "30101": "Domain is unverified",
    "30102": "TLS certificate for your Domain has expired.",
    "30103": "Links not shortened due to application failure.",
    "30104": "Shortened link not found. Click redirected to fallback Url",
    "30105": "Shortened link not found and no fallback URL found",
    "30106": "Domain has not been set up for this account",
    "30107": "Domain private certificate has not been uploaded",
    "30108": "Twilio account does not belong to an organization",
    "30109": "Callback URL is invalid",
    "30110": "Domain is blocked",
    "30111": "Url is on a deny list",
    "30112": "Account is not found",
    "30113": "Specified date is too old",
    "30114": "Specified date is not available yet",
    "30115": "Date format is incorrect",
    "30116": "Certificate or private key or both are missing",
    "30117": "Certificate cannot be parsed",
    "30118": "Private key is invalid",
    "30119": "Certificate and private key pair is invalid",
    "30120": " Domain certificate and private key are not uploaded",
    "30121": "Fallback URL is missing",
    "30122": "Fallback URL is invalid",
    "30123": "Callback URL is missing",
    "30124": "MessagingServiceSID cannot be empty or null",
    "30125": "Your phone number could not be registered with US A2P 10DLC",
    "30126": "Your 10DLC number failed to be registered ",
    "30127": "MessagingServiceSID is invalid.",
    "30128": "MessagingServiceSidsAction is invalid",
    "30129": "Certificate is self signed",
    "30130": "Messaging Service SID already belongs in another domain configuration.",
    "30131": "Domain's certificate will expire soon",
    "30132": "Certificate cannot be validated. ",
    "30133": "The certificate could not be uploaded.",
    "30134": "Invalid Dns Setup for Link shortening",
    "30135": "Unable to issue certificate",
    "30136": "Unable to renew certificate",
    "30400": "Parameters are not valid ",
    "30404": "Not Found",
    "30409": "This message cannot be canceled",
    "30410": "Provider Timeout Error",
    "30436": "Invalid Phone Number SID",
    "30437": "Toll Free verification rejection - Edit time expired",
    "30440": "Toll Free verification rejection - Unknown Error",
    "30441": "Toll-Free phone number verification rejection - Disallowed: SHAFT - Sex",
    "30442": "Toll-Free phone number verification rejection - Disallowed: Spam",
    "30443": "Toll-Free verification rejection - Disallowed: Loan Marketing",
    "30444": "Toll Free verification rejection - Disallowed: Fraud",
    "30445": "Toll Free verification rejection - Could not validate business information",
    "30446": "Toll Free verification rejection - Opt-in not sufficient: express consent required",
    "30447": "Toll Free verification rejection - phone number not provisioned to Twilio",
    "30448": "Toll-Free phone number verification rejection - Age Gate",
    "30449": "Toll Free verification rejection - URL issues in sample message",
    "30450": "Message delivery blocked",
    "30451": "Toll-Free phone number verification unable to process - address invalid",
    "30452": "Toll-Free phone number verification unable to process - email invalid",
    "30453": "Message couldn't be delivered",
    "30454": "Account exceeded the messages limit",
    "30455": "Toll-Free phone number verification rejection - Disallowed: SHAFT - Hate",
    "30456": "Toll Free verification rejection - Disallowed: SHAFT - Alcohol",
    "30457": "Toll Free verification rejection - Disallowed: SHAFT - Firearms",
    "30458": "Toll Free verification rejection - Disallowed: SHAFT - Tobacco / Vape",
    "30459": "Toll Free verification rejection - Disallowed: Cannabis/CBD",
    "30460": "Toll Free verification rejection - Disallowed: Third Party Debt Collection",
    "30461": "Toll Free verification rejection - Disallowed: Gambling",
    "30462": "Toll Free verification rejection - Disallowed: Sweepstakes",
    "30463": "Toll Free verification rejection - Disallowed: Stock Alerts/Platforms",
    "30464": "Toll Free verification rejection - Disallowed: Cryptocurrency",
    "30465": "Toll Free verification rejection - Disallowed: Risk Investment/Get Rich Quick Schemes",
    "30466": "Toll Free verification rejection - Disallowed - Debt Reduction",
    "30467": "Toll Free verification rejection - Disallowed: Credit Repair",
    "30468": "Toll Free verification rejection - Disallowed: Third-party Lead Generation",
    "30469": "Toll Free verification rejection - Disallowed: Illegal substances/articles",
    "30470": "Toll Free verification rejection - High Risk: Deceptive Marketing",
    "30471": "Toll Free verification rejection - High Risk - Non-secured URL in sample message",
    "30472": "Toll Free verification rejection - Could not verify Business",
    "30473": "Toll Free verification rejection - Cannot validate business website URL",
    "30474": "Toll Free verification rejection - Need end business",
    "30475": "Toll Free verification rejection - Opt-in not sufficient: Cannot combine consent for messaging with requirement for service",
    "30476": "Toll Free verification rejection - Opt-in not provided",
    "30477": "Toll Free verification rejection - Opt-in - Third party information sharing not allowed",
    "30478": "Toll Free verification rejection - single phone number used for multiple businesses",
    "30479": "Toll Free verification rejection - justification needed for more than five toll free phone numbers per businesses",
    "30480": "Toll-Free phone number verification rejection - Disallowed - Phishing",
    "30485": "Message couldn't be delivered",
    "30500": "Twilio Internal Error",
    "30610": "Message couldn't be delivered",
    "30615": "Message couldn't be delivered",
    "30620": "Message couldn't be delivered",
    "30630": "Attempt to send to unsubscribed recipient",
    "30646": "Failed to Upsert Consent",
    "30647": "Failed to Upsert Contact",
    "30701": "Brand Registration Failure: Invalid input parameters",
    "30702": "Brand Registration Failure: Registration not found",
    "30703": "Brand Registration Failure: Duplicate record detected",
    "30709": "Subscribers Must Be Opted In When Providing an Opt-In Message",
    "30710": "Deleting a Brand with Active Campaigns is Not Allowed",
    "30711": "Deleting a Brand with Active Brand Sharing is Not Allowed",
    "30712": "Brand Registration Failure: Max registration limit reached",
    "30713": "Invalid Vetting Token",
    "30714": "Vetting Token Rejected by TCR",
    "30715": "Vetting Token Not Allowed for Sole Proprietor Brands",
    "30729": "Brand Registration Failure: Country code not allowed",
    "30734": "Brand Registration Failure: Sole Proprietor brands are not enabled",
    "30747": "Brand Registration Failure: Address duplicate threshold reached",
    "30748": "Brand Registration Failure: Phone number duplicate threshold reached",
    "30749": "Brand Registration Failure: Email address duplicate threshold reached",
    "30750": "Brand Registration Failure: Mobile phone number duplicate threshold reached",
    "30751": "Brand Registration Failure: Unsupported mobile phone number",
    "30752": "Brand Registration Failure: Invalid or expired OTP",
    "30753": "Brand Registration Failure: Unsupported email address",
    "30754": "Brand Registration Failure: Invalid postal address",
    "30755": "Brand Registration Failure: Unsupported country code",
    "30756": "Brand Registration Failure: Obfuscation check failure",
    "30757": "Brand Registration Failure: Missing Business Registration Number ",
    "30758": "Unknown Error Code",
    "30759": "US A2P Registration: Insufficient Permissions to Perform Operation",
    "30790": "Brand Registration Failure: Internal system error",
    "30791": "Brand Registration Failure: Temporary system error",
    "30792": "Brand Registration Failure: General error",
    "30793": "Brand Registration Failure: Validation problems with connected bundles",
    "30794": "US A2P Registration: General error",
    "30795": "Brand Registration Feedback: Data mismatch related to tax id and its associated properties.",
    "30796": "Brand Registration Feedback: Non public entity registered as a public for profit entity or the stock information mismatch.",
    "30797": "Brand Registration Feedback: Non government entity registered as a government entity. Must be a U.S. government entity.",
    "30798": "Brand Registration Feedback: No IRS 501c tax-exempt status found.",
    "30799": "Brand Registration Feedback: We were unable to verify the details of the registration data.",
    "30880": "Campaign vetting rejection - Unknown Error",
    "30881": "Campaign vetting rejection - Invalid Brand Support Email",
    "30882": "Campaign vetting rejection - Terms & Conditions",
    "30883": "Campaign vetting rejection - Content Violation",
    "30884": "Campaign vetting rejection - Spam/Phishing",
    "30885": "Campaign vetting rejection - High Risk",
    "30886": "Campaign vetting rejection - Invalid Campaign Description",
    "30887": "Campaign vetting rejection - Opt-out Error",
    "30888": "Campaign vetting rejection - Age Gate Not Present / Not Acceptable",
    "30889": "Campaign vetting rejection - Embedded Phone Number",
    "30890": "Campaign vetting rejection - Subscriber Help",
    "30891": "Campaign vetting rejection - Invalid Website URL",
    "30892": "Campaign vetting rejection - Invalid Sample Message - Public URL Shorteners",
    "30893": "Campaign vetting rejection - Inconsistency between Sample Message and Use-case",
    "30894": "Campaign vetting rejection - Invalid Brand Information",
    "30895": "Campaign vetting rejection - Direct Lending - Campaign and Content Attribute Error",
    "30896": "Campaign vetting rejection - Opt-in Error",
    "30897": "Campaign vetting rejection - Disallowed Content",
    "30898": "Campaign vetting rejection - Excessive EIN  ",
    "30899": "Campaign rejection - The campaign registration failed because of carrier rejection(s).",
    "30900": "Campaign rejection - The campaign use case is ineligible for registration.",
    "30901": "Campaign rejection - The campaign registration request timed out.",
    "30902": "Campaign rejection - A DCA2 rejected this campaign registration request.",
    "30903": "Campaign rejection - Incorrect Sole Prop Brand Registration",
    "30904": "Campaign Not Shared with Twilio",
    "30905": "Campaign Review Pending by Twilio",
    "30906": "Campaign Rejected by Twilio",
    "30907": "Campaign vetting rejection - Website URL Validation Issue",
    "30908": "Campaign vetting rejection - Compliant Privacy Policy Required",
    "30909": "Campaign vetting rejection - CTA Verification Issue",
    "30990": "Campaign Suspension",
    "30991": "Campaign Registration Failed",
    "30992": "Campaign Registration Failed",
    "30993": "Campaign Registration Failed",
    "30994": "Campaign Registration Failed",
    "31000": "Generic error",
    "31001": "Application not found.",
    "31002": "Connection declined.",
    "31003": "Connection timeout",
    "31005": "Connection error",
    "31006": "Audio device error",
    "31007": "Twilio Client: Client version not supported",
    "31008": "Call cancelled",
    "31009": "Transport error",
    "31100": "Malformed request",
    "31101": "Missing parameter array in request.",
    "31102": "Authorization token missing in request.",
    "31103": "Length of parameters cannot exceed MAX_PARAM_LENGTH.",
    "31104": "Invalid bridge token.",
    "31105": "Invalid client name",
    "31106": "Invalid data",
    "31201": "Twilio Client: Error occurred while accessing microphone",
    "31202": "Signature validation failed.",
    "31203": "No valid account.",
    "31204": "Invalid JWT token.",
    "31205": "JWT token expired.",
    "31206": "Rate exceeded authorized limit.",
    "31207": "JWT token expiration too long.",
    "31208": "User denied access to microphone.",
    "31209": "Reconnect attempt error.",
    "31210": "Call Message Event Type is invalid.",
    "31211": "Call is not in the expected state.",
    "31212": "Call Message Event Payload size exceeded authorized limit.",
    "31301": "Registration error",
    "31302": "Unsupported Cancel Message Error",
    "31400": "Bad Request",
    "31401": "UserMedia Permission Denied",
    "31402": "UserMedia Acquisition Failed",
    "31403": "Forbidden",
    "31404": "Not Found",
    "31408": "Request Timeout",
    "31409": "Conflict",
    "31426": "Upgrade Required",
    "31429": "Too Many Requests",
    "31480": "Temporarily Unavailable",
    "31481": "Call/Transaction Does Not Exist",
    "31484": "Address Incomplete",
    "31486": "Busy Here",
    "31487": "Request Terminated",
    "31500": "Internal Server Error",
    "31502": "Bad Gateway",
    "31503": "Service Unavailable",
    "31504": "Gateway Timeout",
    "31530": "DNS Resolution Error",
    "31600": "Busy Everywhere",
    "31603": "Decline",
    "31604": "Does Not Exist Anywhere",
    "31900": "Stream - Unknown Error",
    "31901": "Stream - WebSocket - Connection Timeout",
    "31902": "Stream - WebSocket - Connection Refused",
    "31903": "Stream - WebSocket - Connection Broken Pipe",
    "31904": "Stream - WebSocket - Host Unreachable",
    "31910": "Stream - WebSocket - SSL Protocol Error",
    "31920": "Stream - WebSocket - Handshake Error",
    "31921": "Stream - WebSocket - Close Error",
    "31922": "Stream - WebSocket - URL Schema Not Supported",
    "31923": "Stream - WebSocket - Malformed URL",
    "31924": "Stream - Websocket - Protocol Error",
    "31930": "Stream - Media - Buffer Overflow",
    "31931": "Stream - Media - Media Discarded",
    "31940": "Stream - Invalid connectorName attribute in TwiML.",
    "31941": "Stream - Invalid Track configuration",
    "31942": "Stream - Invalid connector configuration",
    "31950": "Stream - Protocol - Malformed Message",
    "31951": "Stream - Protocol - Invalid Message",
    "31952": "Stream Extension not found: ",
    "31953": "Stream - Media - RTP timeout",
    "31960": "Stream - Quota exceeded",
    "32001": "SIP: Trunk CPS limit exceeded",
    "32002": "SIP: Dial failure - Twilio SIP Domain not found",
    "32005": "Voice calling has been disabled for this account",
    "32006": "SIP: Too many hops",
    "32007": "SIP: Too many endpoints/bindings for the Address-of-record (AOR)",
    "32008": "SIP: Registration per second limit reached",
    "32009": "The user you tried to dial is not registered with the corresponding SIP Domain",
    "32010": "SIP: No valid Origination URIs configured",
    "32011": "Error communicating with your SIP communications infrastructure",
    "32012": "SIP: Parent account pooled Trunking CPS limit exceeded",
    "32013": "SIP: Parent account SIP Interface CPS limit exceeded",
    "32014": "Call is terminated because of no audio received",
    "32015": "Call is terminated due to exceeding maximum call duration",
    "32016": "PSTN PDD timeout",
    "32017": "PSTN: Carrier blocked call due to calling number (caller ID)",
    "32018": "Twiml size exceeded maximum allowed value",
    "32019": "Twiml and Voice URL are both set. Using Voice URL.",
    "32020": "SHAKEN/STIR call verification failed due to invalid passport from customer",
    "32021": "SHAKEN/STIR call verification failed",
    "32022": "ACK not received from your SIP endpoint",
    "32100": "SIP: Trial accounts can only call verified caller IDs",
    "32101": "SIP: Invalid phone number",
    "32102": "SIP: Bad SDP",
    "32103": "SIP: Empty body",
    "32105": "SIP: Invalid contact header",
    "32106": "SIP: Authentication Error",
    "32110": "SIP: URI is formatted incorrectly",
    "32111": "SIP: Invalid header name",
    "32112": "SIP: Invalid header value",
    "32113": "SIP: Header name is not allowed",
    "32114": "SIP: Unsupported parameter value",
    "32115": "X-Branded-CallReason header contains an invalid value.",
    "32200": "SIP: Insufficient permissions",
    "32201": "SIP: Source IP address not in ACL",
    "32202": "SIP: Bad user credentials",
    "32203": "SIP: Call blocked by Twilio",
    "32204": "SIP: 'From' phone number not verified",
    "32205": "SIP Trunking: Geo Permission configuration is not permitting call",
    "32206": "SIP: Invalid From number (caller ID)",
    "32207": "SIP: Secure media not accepted",
    "32208": "SIP: Secure media required",
    "32209": "SIP: Secure transport required",
    "32210": "SIP: Register not supported",
    "32212": "SIP: Registration Authentication problem",
    "32214": "SIP: Invalid <Dial><Sip> ",
    "32215": "Dial failure calling a SIP Domain without specifying a region",
    "32216": "SIP: SIP Address is on a deny list",
    "32218": "SIP: Transfer not allowed",
    "32219": "SIP: Redirect failed",
    "32220": "Specifying an edge is not allowed when dialing SIP registered endpoints",
    "32221": "Dialing SIP Endpoint failure - No devices registered in specified edge",
    "32222": "TLS version not allowed",
    "32223": "There is no username in the SIP URI when calling a SIP registered endpoint",
    "32301": "Interconnect: Invalid Connection (TNX) SID",
    "32302": "Interconnect: Connection (TNX) SID not found",
    "32303": "Interconnect: Multiple SIP Dials with Interconnect Connection (TNX) SID",
    "32304": "Interconnect: Connection (TNX) SID is not Active",
    "32400": "BYOC Trunk routing failure - failover routing disabled.",
    "32401": "BYOC Trunk routing failure - failover to Twilio default routing.",
    "32500": "Voice Conversation: Generic error.",
    "32501": "Voice Conversation: TwiML attributes validation error.",
    "32502": "Voice Conversation: Callback event internal error.",
    "32503": "Voice Conversation: Callback event response error.",
    "32504": "Voice Conversation: Incomplete Conversation.",
    "32505": "Voice Conversation: Invalid data inside existing conversation.",
    "32506": "Voice Conversation: Failed to get worker assigned to a newly created Conversation.",
    "32600": "Virtual Agent: Configuration Error",
    "32601": "Virtual Agent: Provider Error",
    "32602": "Virtual Agent: Invalid Connector",
    "32603": "Virtual Agent: Unsupported <Config> attribute(s) in TwiML",
    "32604": "Virtual Agent: Internal Error",
    "32605": "Virtual Agent: PCI Error",
    "32606": "Virtual Agent: Resume Error",
    "32650": "Real-time Transcriptions: Configuration Error",
    "32651": "Real-time Transcriptions: Provider Error",
    "32652": "Real-time Transcriptions: Unsupported <Config> attribute(s) in TwiML",
    "32653": "Real-time Transcriptions: Internal Error",
    "32654": "Real-time Transcriptions: PCI Error",
    "32655": "Real-time Transcriptions: Intelligence Service Unreachable",
    "32700": "Voice User-Defined Message: Internal Twilio Error",
    "32701": "Voice User-Defined Message: Invalid Content-Type",
    "32702": "Voice User-Defined Message: Invalid Content",
    "32703": "Voice User-Defined Message: Content body exceeded max length",
    "32710": "Voice User-Defined Message: Subscription Callback Internal Error",
    "32711": "Voice User-Defined Message: Request to subscription callback URL encountered error ",
    "33000": "Generic Error",
    "33004": "Service is unavailable\t",
    "33010": "Conflicting update",
    "33101": "Invalid Parameter Value\t",
    "33102": "Parameter missing",
    "33103": "Paging information invalid",
    "33104": "Configuration incomplete",
    "33105": "Transition invalid",
    "33107": "SIM not found",
    "33108": "Rate Plan not found",
    "33111": "Command exceeded max length",
    "33118": "Number of Commands exceeded",
    "33119": "SIM connectivity reset not allowed",
    "33120": "SIM connectivity reset in progress",
    "33121": "Invalid Parameter Combination",
    "33122": "Rate Plan Is Not Allowed",
    "33201": "Unauthorized",
    "33203": "Messaging not allowed",
    "34002": "Callee Busy",
    "34003": "Callee did not answer",
    "34004": "Error during fax transmission",
    "34005": "Programmable Fax is no longer available",
    "34106": "No Fax TwiML action specified",
    "34108": "Other End Incompatible",
    "35111": "SendAt timestamp is missing",
    "35114": "Scheduling does not support this timestamp",
    "35115": "Scheduling does not support this timestamp",
    "35117": "Scheduling does not support this timestamp",
    "35118": "MessagingServiceSid is required to schedule a message",
    "35125": "Maximum limit reached in the account for scheduling messages",
    "35126": "The ScheduleType value provided is not supported for this channel",
    "35127": "'Messages' Body and ContentVariables cannot be provided together",
    "35132": "Bulk : Provided Attributes JSON is not valid",
    "35133": "Invalid 'Messages' array provided in the request",
    "35134": "`Messages` array contains duplicate `To` numbers.",
    "36001": "Broadcast SID Not Found",
    "36002": "Broadcast Request Limit Reached",
    "36003": "Broadcast Upload File Size Exceeded",
    "36004": "Error Retrieving File",
    "36005": "Broadcast File Type Invalid",
    "36006": "Broadcast Cannot Be Canceled",
    "36007": "Broadcast Upload Status Check Failure",
    "36008": "Invalid Page Token",
    "36009": "Stats for Broadcast SID Not Found",
    "37000": "WhatsApp Voice: Call permission not granted by consumer",
    "37001": "WhatsApp Voice: Outbound calls are not supported in this region",
    "40000": "Content-Type of 'application/json' not set",
    "40001": "Could not parse Assignment Instruction response as JSON. Ensure your JSON is not escaped",
    "40005": "Assignment Callback response does not contain Instruction",
    "40100": "TaskRouter->Reject",
    "40110": "TaskRouter->Call",
    "40111": "TaskRouter->Call",
    "40112": "TaskRouter->Call",
    "40113": "TaskRouter->Call",
    "40114": "TaskRouter->Call",
    "40120": "TaskRouter->Direct",
    "40121": "TaskRouter->Direct",
    "40122": "TaskRouter->Direct",
    "40123": "TaskRouter->Redirect",
    "40130": "TaskRouter->Dequeue",
    "40131": "TaskRouter->Dequeue",
    "40132": "TaskRouter->Dequeue",
    "40133": "TaskRouter->Dequeue",
    "40134": "Dequeue Instruction does not have a valid 'status_callback_events' parameter",
    "40135": "TaskRouter->Dequeue",
    "40136": "TaskRouter->Conference",
    "40137": "Missing 'to' parameter when issuing Conference instruction",
    "40138": "Missing 'from' parameter when issuing Conference instruction",
    "40139": "Failed to issue Conference Instruction due to invalid ActivitySid",
    "40140": "Failed to issue Dequeue instruction due to missing 'call_sid' property",
    "40141": "TaskRouter->Conference",
    "40142": "Failed to issue Conference instruction due to missing 'call_sid' or 'outbound_to' properties",
    "40143": "TaskRouter->Conference",
    "40144": "TaskRouter->Conference",
    "40145": "TaskRouter->Conference",
    "40146": "Failed to issue Supervise Instruction due to invalid Reservation state",
    "40147": "Failed to issue Supervise instruction due to missing or invalid 'contact_uri' property",
    "40148": "Failed to issue Supervise instruction due to missing ‘from’ property",
    "40149": "Failed to issue Conference instruction due to missing ‘conference_sid’",
    "40151": "TaskRouter->Invalid instruction",
    "40152": "Invalid Queue for Known Worker",
    "40153": "Absolute Paging used when iterating TaskRouter resources",
    "40154": "Invalid Known Worker information",
    "40155": "Invalid Workspace for Known Worker",
    "40157": "Dequeue Instruction does not have a valid 'status_callback_url' parameter",
    "40158": "Call Instruction does not have a valid 'status_callback_url' parameter",
    "40159": "Conference Instruction does not have a valid 'status_callback_url' parameter",
    "45001": "General Service Error",
    "45002": "Authentication Error",
    "45003": "Authorization Error",
    "45004": "Validation Error",
    "45005": "Service Unavailable",
    "45006": "Resource Not Found",
    "45007": "Resource Conflict Error",
    "45008": "Unprocessable Request",
    "45009": "Configuration Error",
    "45010": "Rate Limit Exceeded",
    "45050": "Authentication error - Missing User Attributes",
    "45101": "Configuration Not Found",
    "45102": "Collision On Configuration Change",
    "45103": "Workspace Not Configured",
    "45109": "Skills Limit Exceeded",
    "45201": "Resource Not Found",
    "45202": "Resource Already Exists",
    "45203": "Requested Chat User not found",
    "45204": "Requested Flex Chat Channel is not found",
    "45205": "Requested Flex Flow is not found",
    "45206": "Chat User is already a member of the Chat Channel",
    "45207": "Chat User per Chat Channel limit reached. User is part of too many Chat Channels.",
    "45208": "Chat Channel with this unique name already exists",
    "45209": "Adding a user to the Chat Channel has timed out waiting for a response from Twilio Chat.",
    "45210": "Flex Flow creation failed",
    "45211": "Provided identity is reserved by system",
    "45212": "Flex Flow creation failed",
    "45301": "Error occurred when connecting to a Meeting Participant",
    "45302": "Participant was disconnected before setting up Meeting",
    "45303": "Participant was busy",
    "45304": "Internal timeout error",
    "45305": " No answer from Participant",
    "45306": "Meeting was canceled",
    "45307": "Add Participant Not Allowed",
    "45308": "Add Participant Not Allowed",
    "45309": "Modify Participant Not Allowed",
    "45310": "Participant Not Found",
    "45312": "Remove Participant Request Failed",
    "45313": "Transfer Failed",
    "45350": "An unexpected error occurred.",
    "45351": "Invalid Channel Participant properties.",
    "45352": "Failed to create an outbound Channel.",
    "45353": "A duplicate create Channel request was dropped.",
    "45354": "Cannot create a Channel for a closed Conversation.",
    "45355": "Failed to create a channel.  No Participants found.",
    "45356": "Failed to create a channel. Downstream error.",
    "45357": "Downstream error configuring Channel.",
    "45358": "Failed to close Channel.  Missing status parameter.",
    "45359": "Failed to close Channel.  Invalid status parameter.",
    "45360": "Failed to close or delete Conversation.  Downstream error.",
    "45361": "Failed to add Participant. Downstream error.",
    "45362": "Failed to remove Participant.  Not found.",
    "45363": "Failed to remove Participant.  Downstream error.",
    "45366": "Failed to create Channel.  Invalid request parameters.",
    "45367": "Failed to add Participant.  Invalid request parameters.",
    "45368": "Failed to delete Channel.  Not found.",
    "45369": "Failed to create inbound Channel.  Internal error.",
    "45370": "Failed to create outbound Channel.  Internal error.",
    "45371": "Failed to close Channel.  Internal error.",
    "45372": "Failed to add Participant.  Internal error.",
    "45373": "Failed to remove Participant.  Internal error.",
    "45374": "Failed to delete Channel.  Internal error.",
    "45375": "Failed to delete Channel.  Invalid Account sid.",
    "45376": "Failed to add a participant.  Conversation was closed or not found.",
    "45377": "Account SID not authorized. ",
    "45378": "Failed to inactivate Channel. Internal error.",
    "45379": "Failed to inactivate Channel. Downstream error.",
    "45380": "Failed to activate Channel. Internal error.",
    "45381": "Failed to activate Channel. Downstream error.",
    "45401": "RTA feed callback returned not successful response code",
    "45402": "RTA feed callback response time exceeded the threshold",
    "45600": "Flex UI error",
    "45601": "Custom Flex UI error",
    "45700": "Unexpected error occurred. Unable to process WebChat request.",
    "45701": "Unexpected error occurred. Service unavailable. ",
    "45711": "Failed to create webchat participant. Unauthorized ",
    "45715": "Failed to create webchat participant. Invalid request parameters. ",
    "45719": "Failed to create webchat participant. Too many requests ",
    "45731": "Pre-engagement data too large. ",
    "45733": "Pre-engagement data is not in valid JSON format.",
    "45741": "Failed to create webchat conversation. Account not authorized ",
    "45744": "Failed to create webchat conversation. A resource provided could not be found. ",
    "45745": "Invalid or missing parameters in the create conversation request.",
    "45760": "Unable to validate address configuration. Auto create data missing.  ",
    "45761": "Failed to validate address configuration. Auto create not enabled.",
    "45762": "Failed to validate address configuration. Auto create type is empty or invalid. ",
    "45763": "Unable to validate address configuration. Auto create studio flow SID missing. ",
    "45764": "Unable to validate address configuration. Auto create webhook URL missing. ",
    "45765": "Address configuration data not found",
    "45770": "Failed to create InteractionChannel. Downstream Error. ",
    "45771": "Failed to create InboundConversation. Internal Error.",
    "45772": "Failed to perform operation. Required header is either missing or incorrect.",
    "45773": "Internal Error. Failed to create token.",
    "45774": "Internal Error. Failed to refresh token.",
    "45775": "Failed to refresh token. Invalid token provided.",
    "45776": "Failed to fetch Configuration for deployment key.",
    "45777": "Address Configuration not found for deployment key.",
    "45778": "Configuration not found for provided Deployment Key.",
    "45780": "Failed to perform this operation. Account is sending too many concurrent API  requests.",
    "45781": "Internal Error. Failed to create deployment key.",
    "45782": "Internal Error. Failed to delete deployment key.",
    "45784": "Internal Error. Failed to get deployment keys.",
    "45785": "Internal Error. Failed to delete deployment keys.",
    "45788": "Internal Error. Failed to update deployment key.",
    "45789": "Deployment key is already linked to other address  configuration sid.",
    "45794": "Max deployment keys limit reached for this account.",
    "45795": "Friendly name must be between 1 and  64 characters long.",
    "45796": "Failed to perform this operation. There  was a conflict with the state of the  resource.",
    "45797": "Support Access Token Generated",
    "45798": "Error processing SCIM request - internal server error",
    "45799": "Error processing SCIM request - client error",
    "48000": "Invalid request payload",
    "48001": "Callback URL is not set",
    "48002": "Callback URL is invalid",
    "48003": "Callback returned an invalid response",
    "48004": "Callback returned an error",
    "48005": "Callback failed due to timeout",
    "48010": "Custom Routing Callback failed to execute successfully",
    "48011": "Custom Routing Callback failed due to an internal error",
    "48023": "Frontline user conversation limit exceeded",
    "48024": "Contact conversation limit exceeded",
    "48025": "Outgoing conversation: Invalid contact address",
    "48026": "Outgoing conversation: Invalid proxy address",
    "48027": "Outgoing conversation: Proxy address equals contact address",
    "48028": "Outgoing conversation: Unauthorized use of the proxy address",
    "48029": "Outgoing conversation: Contact address type does not match proxy address type",
    "48030": "Outgoing conversation: Proxy address is not WhatsApp-enabled sender",
    "48031": "Outgoing conversation: Conversation with this contact and proxy address already exists",
    "48032": "Outgoing conversation: Missing Messaging service",
    "48033": "Outgoing conversation: Invalid contact identity",
    "48050": "Internal service error",
    "49008": "Profile Connector Installation Not Found",
    "49009": "Credentials Malformed",
    "50000": "Programmable Chat: FriendlyName not provided",
    "50001": "Programmable Chat: Account SID not provided",
    "50002": "Programmable Chat: Resource is being deleted",
    "50003": "Programmable Chat: Friendly name too long",
    "50004": "Programmable Chat: Unique Name too long",
    "50006": "Programmable Chat: Invalid Account SID",
    "50050": "Programmable Chat: Service Instance not found",
    "50051": "Programmable Chat: Service SID not provided",
    "50052": "Programmable Chat: Invalid consumption interval format",
    "50053": "Programmable Chat: Invalid typing indicator format",
    "50054": "Programmable Chat: Invalid webhook format",
    "50055": "Programmable Chat: Invalid webhook method",
    "50056": "Programmable Chat: Webhook disabled processing of command",
    "50057": "Programmable Chat: Webhook call failed to execute successfully",
    "50058": "Programmable Chat: Notification template too long",
    "50059": "Programmable Chat: Notification sound name too long",
    "50060": "Programmable Chat: Invalid user channels limit format",
    "50061": "Programmable Chat: Invalid channel members limit format",
    "50063": "Programmable Chat: Actions per second limit exceeded",
    "50065": "Programmable Chat: Invalid webhook retry count",
    "50068": "Programmable Chat: Service instance unique name invalid",
    "50069": "Programmable Chat: Service instance with provided unique name already exists",
    "50074": "Global actions per second limit exceeded",
    "50076": "Webhook failed to execute successfully due to timeout",
    "50077": "Invalid pre-webhook url",
    "50078": "Invalid post-webhook url",
    "50100": "Programmable Chat: Role not found",
    "50101": "Programmable Chat: Channel role not found",
    "50102": "Programmable Chat: Deployment role not found",
    "50103": "Programmable Chat: Role SID not provided",
    "50104": "Programmable Chat: Permission not found",
    "50105": "Programmable Chat: Invalid role type",
    "50106": "Programmable Chat: Channel creator role not found",
    "50107": "Programmable Chat: User not authorized for command",
    "50109": "Conversation role not found",
    "50200": "Programmable Chat: User not found",
    "50201": "Programmable Chat: User already exists",
    "50202": "Programmable Chat: User SID not provided",
    "50203": "Programmable Chat: Identity reserved",
    "50204": "Programmable Chat: Identity not provided",
    "50205": "Programmable Chat: User unauthorized to set role",
    "50206": "Programmable Chat: Identity should not match user SID pattern",
    "50207": "Programmable Chat: Identity too long",
    "50208": "Programmable Chat: User channel limit exceeded",
    "50209": "Programmable Chat: Invalid binding type",
    "50210": "Programmable Chat: Invalid notification level",
    "50211": "Identity parameter not acceptable for this Participant",
    "50212": "Programmable Chat: User already invited",
    "50213": "Conflicting user modification",
    "50214": "User conversation limit exceeded",
    "50300": "Programmable Chat: Channel not found",
    "50301": "Programmable Chat: Channel key not provided",
    "50302": "Programmable Chat: Unknown channel command",
    "50303": "Programmable Chat: Attributes too long",
    "50304": "Programmable Chat: Attributes not valid JSON",
    "50305": "Programmable Chat: Channel SID not provided",
    "50306": "Programmable Chat: Unique name should not match channel SID pattern",
    "50307": "Programmable Chat: Channel with provided unique name already exists",
    "50308": "Programmable Chat: Invalid Date Created parameter",
    "50309": "Programmable Chat: Invalid Date Updated parameter",
    "50310": "Programmable Chat: Author parameter is too long",
    "50320": "Programmable Chat: Channel webhook not found",
    "50321": "Programmable Chat: Too many channel webhooks",
    "50322": "Programmable Chat: Too many channel webhook triggers",
    "50323": "Programmable Chat: Invalid channel webhook sid",
    "50324": "Invalid channel webhook type",
    "50325": "Programmable Chat: Invalid channel webhook filter",
    "50326": "Programmable Chat: Invalid channel webhook trigger",
    "50327": "Programmable Chat: Invalid channel webhook flow sid",
    "50328": "Programmable Chat: Channel webhook type not provided",
    "50329": "Programmable Chat: Channel webhook url not provided",
    "50330": "Programmable Chat: Channel webhook filter not provided",
    "50331": "Programmable Chat: Channel webhook trigger not provided",
    "50332": "Programmable Chat: Channel webhook url too long",
    "50334": "Channel deletion operation is in progress",
    "50340": "Messaging service SID not provided",
    "50341": "Invalid messaging service SID",
    "50342": "Messaging service does not belong to account",
    "50347": "Parameters are missing for channel update request",
    "50349": "Conflicting channel modification",
    "50350": "Conversation not found",
    "50351": "Conversation SID not provided",
    "50353": "Conversation with provided unique name already exists",
    "50360": "Conversation webhook not found",
    "50361": "Too many conversation webhooks",
    "50362": "Too many conversation webhook triggers",
    "50363": "Invalid conversation webhook SID",
    "50364": "Invalid conversation webhook type",
    "50365": "Invalid conversation webhook filter",
    "50366": "Invalid conversation webhook trigger",
    "50367": "Invalid conversation webhook flow SID",
    "50368": "Conversation webhook type not provided",
    "50369": "Conversation webhook URL not provided",
    "50370": "Conversation webhook filter not provided",
    "50371": "Conversation webhook trigger not provided",
    "50372": "Conversation webhook URL is too long",
    "50373": "No Messaging Service assigned to Conversation",
    "50374": "'State' field can't be empty",
    "50375": "TimeToInactive should be greater or equal to 1 minute",
    "50376": "TimeToClosed should be greater or equal to 10 minutes",
    "50377": "Can't update conversation as it's in final closed state",
    "50378": "'State' parameter value is invalid",
    "50379": "TimeToInactive format is invalid",
    "50380": "TimeToClosed format is invalid",
    "50382": "Timer can't be set without state",
    "50384": "Initial state can't be 'closed",
    "50385": "Conversations are disabled in this region",
    "50386": "Conversation in 'initializing' state may not be updated or used for message sending",
    "50390": "Unique name should not match conversation sid pattern",
    "50391": "Conflicting conversation modification",
    "50392": "PreWebhookTimeout should be greater than 0ms",
    "50393": "Type value should be 'private'.",
    "50396": "EndDate parameter should be greater than StartDate parameter",
    "50400": "Programmable Chat: User not member of channel",
    "50401": "Programmable Chat: Member SID not provided",
    "50402": "Programmable Chat: Member not found",
    "50403": "Programmable Chat: Channel member limit exceeded",
    "50404": "Programmable Chat: Member already exists",
    "50405": "Programmable Chat: Invalid last consumption timestamp format",
    "50406": "Programmable Chat: Invalid last consumed message index format",
    "50407": "Invalid messaging binding address",
    "50408": "Invalid participant proxy address",
    "50409": "Participant address equals proxy address",
    "50411": "Participant address is empty",
    "50412": "Participant proxy address is empty",
    "50413": "Account is not authorized to use proxy address",
    "50414": "Participant address type does not match proxy address type",
    "50415": "Proxy address is not WhatsApp enabled sender",
    "50416": "Participant and proxy address pair is already in use",
    "50417": "Participants limit exceeded",
    "50418": "Non-Chat participants limit exceeded",
    "50419": "Conflicting member modification",
    "50420": "Participant Messaging Binding type does not support all of the provided Messaging Binding parameters",
    "50421": "Invalid last read message index format",
    "50422": "Non-chat conversation participants limit exceeded",
    "50424": "One of the JSON requests for participant creation is invalid.",
    "50425": "Participant and proxy address pairs for one or more participants already in use.",
    "50426": "Request contains too many participants.",
    "50427": "Errors occurred during multiple participants creation.",
    "50430": "Participant is not a member of conversation",
    "50431": "Participant SID not provided",
    "50432": "Participant not found",
    "50433": "Participant already exists",
    "50434": "Participant projected address not provided",
    "50435": "Group MMS activation failed.",
    "50436": "Participant limit exceeded for group conversation",
    "50437": "Group Participant already exists",
    "50438": "Group conversation with given participant list already exists",
    "50439": "Account is not authorized to use the projected address",
    "50440": "Failed to remove the proxy address of a participant.",
    "50441": "Failed to add a proxy address to a participant.",
    "50442": "Failed to remove the projected address of a participant.",
    "50443": "Failed to add a projected address to a participant.",
    "50444": "Failed to add an identity to a participant.",
    "50449": "Conflicting channel modification",
    "50451": "One user identifier parameter for lookup at a time is allowed. Please, use either Identity or Address.",
    "50452": "Group MMS is not enabled for this Account",
    "50453": "Proxy Address of participant is not supported for this channel",
    "50500": "Programmable Chat: Message not found",
    "50501": "Programmable Chat: Message SID not provided",
    "50502": "Programmable Chat: Message index not provided",
    "50503": "Programmable Chat: Message body not provided",
    "50504": "Programmable Chat: Message body parameter is too long",
    "50505": "Programmable Chat: Last Updated By parameter is too long",
    "50506": "Programmable Chat: Media SID not provided",
    "50507": "Programmable Chat: Media not found",
    "50508": "Programmable Chat: Media already sent with another message",
    "50509": "Programmable Chat: Media message body cannot be updated",
    "50510": "Invalid message media SID",
    "50511": "Invalid message media content type",
    "50512": "Message media size is too large",
    "50513": " Message author should be among Group MMS participants.",
    "50514": "Conflicting message modification",
    "50516": "Programmable Chat: Message index is not a number",
    "50526": "Invalid content SID",
    "50527": "Invalid content variables format",
    "50528": "Content SID is missing",
    "50529": "Content variables are too long",
    "50530": "Channel Metadata not found",
    "50531": "Not Authorized to make this request",
    "50532": "Failed to create Channel Metadata",
    "50533": "Failed to parse ChannelMetadata Json",
    "50534": "Failed to Read ChannelMetadata",
    "50540": "Content variable key is too long",
    "50541": "Content variable value is too long",
    "50542": "Unsupported Content Template Type",
    "50600": "Programmable Chat: Invite SID not provided",
    "50601": "Programmable Chat: Invite not found",
    "50602": "Programmable Chat: Cannot decline invite when already channel member.",
    "50610": "Address configuration deleted",
    "50700": "Virtual Agent provider is invalid.",
    "50701": "Only one Virtual Agent participant is allowed per conversation.",
    "50702": "Verify Agent participant should not have identity, user address, proxy address, projected address.",
    "50703": "DialogflowCX provider must contain module sid and addon sid.",
    "50704": "Provided addon sid should have prefix XB.",
    "50705": "Provided module sid should have prefix XE.",
    "50706": "Updating Virtual Agent participant information is not allowed.",
    "50707": "Virtual Agent participant creation is not available for your account.",
    "50708": "ChatbotConfiguration.FriendlyName is required parameter.",
    "50709": "ChatbotConfiguration.FriendlyName is invalid.",
    "50710": "ChatbotConfiguration.InitialContext is invalid.",
    "50711": "ChatbotConfiguration.FriendlyName is reserved.",
    "51001": "Client Connection: Connections resource limit exceeded",
    "51002": "Client Connection: Request rate limit exceeded",
    "51003": "Client Connection: identity too long",
    "51004": "Client Connection: endpoint_id too long",
    "51005": "Client Connection: Command or keepalive acknowledgement not received",
    "51006": "Client Connection: Connection expired",
    "51007": "Client Connection: Token authentication is rejected",
    "51101": "Twilsock: Service instance not found",
    "51102": "Twilsock: Service instance SID not specified",
    "51103": "Twilsock: Token doesn't contain required grants section",
    "51104": "Twilsock: Token doesn't contain service instance",
    "51105": "Twilsock: Token doesn't contain identity",
    "51106": "Twilsock: Active product doesn't match with service instance product",
    "51107": "Twilsock: Service can't be used",
    "51108": "Twilsock: Service instance disabled",
    "51109": "Twilsock: Service instance is under legal hold",
    "51110": "Twilsock: Token contains multiple grants of same product",
    "51111": "Twilsock: Service instance limit reached",
    "51112": "Twilsock: Product usage disabled",
    "51113": "Twilsock: Product usage is not enabled",
    "51114": "Twilsock: Invalid access token header",
    "51115": "Twilsock: Invalid access token subject",
    "51116": "Twilsock: Invalid access token grants",
    "51117": "Twilsock: Invalid access token signature",
    "51118": "Twilsock: Invalid claim set",
    "51119": "Twilsock: Token expired",
    "51120": "Twilsock: Token is not valid yet",
    "51121": "Twilsock: Token expiration time exceeds maximum",
    "51122": "Twilsock: Authentication failed",
    "51123": "Twilsock: Upstream not resolved",
    "51124": "Twilsock: Too many connections",
    "51125": "Twilsock: Too many updates",
    "51126": "Twilsock: DNC limit has been reached",
    "51127": "Twilsock: PNC limit has been",
    "51128": "Twilsock: Too many messages per connection",
    "51129": "Twilsock: Too many messages per account",
    "51130": "Twilsock: Token is invalid!",
    "51131": "Twilsock: Authentication failed",
    "51201": "Twilsock : CPS, Init per Account",
    "51202": "Twilsock : CPS, Too many requests",
    "51215": "Twilsock: Unauthorized",
    "52000": "Internal notification error",
    "52001": "Invalid destination binding",
    "52002": "Invalid Credential Sid",
    "52003": "Invalid Credential Type",
    "52004": "Credential SID not specified",
    "52051": "Internal error when sending notification via client connection",
    "52052": "Client connection not created or closed",
    "52071": "Internal error when sending notification via mqtt client connection",
    "52072": "Client mqtt connection not created or closed",
    "52101": "Invalid GCM Api Key or FCM Secret",
    "52102": "Invalid GCM/FCM registration token",
    "52103": "GCM/FCM client uninstalled or turned off notifications",
    "52104": "Mismatched GCM/FCM sender ID",
    "52105": "Invalid GCM/FCM package name",
    "52106": "Notification too large for GCM/FCM",
    "52107": "Invalid custom key for GCM/FCM",
    "52108": "GCM/FCM device message rate exceeded",
    "52109": "GCM/FCM unauthorized error",
    "52110": "GCM/FCM service unavailable",
    "52111": "GCM/FCM unknown error",
    "52115": "Service account does not have permission to send FCM messages",
    "52116": "Legacy FCM server key credential used to send notifications",
    "52117": "Deprecated GCM/FCM API is used to send notifications",
    "52131": "Invalid APNs credentials",
    "52133": "Invalid APNs device token size",
    "52134": "Invalid APNs device token",
    "52135": "Missing subject in APNs certificate",
    "52136": "Missing payload for APNs delivery",
    "52137": "Invalid size of subject in APNs certificate",
    "52138": "APNs payload too large",
    "52139": "APN service shutdown",
    "52140": "Unknown APNs error",
    "52141": "The provided APNs device token has been unregistered",
    "52142": "The provided APNs device token is not correct",
    "52143": "The push notification was rejected by APNs",
    "52144": "APNs experienced an internal error",
    "52145": "Failed to authenticate with APNs",
    "52147": "Too many APNs provider token updates",
    "52148": "Expired APNs provider token used",
    "52149": "Invalid APNs provider token used",
    "52161": "Empty Credentials",
    "52162": "Credentials do not belong to used account",
    "52163": "Incorrect URL used to retrieve Webhook Credentials",
    "52164": "No Credentials found for the supplied Binding Type",
    "52165": "No Credentials found for the supplied Identifier",
    "52166": "Webhook Credentials endpoint responded with Internal Error",
    "52167": "Invalid Webhook Credentials response",
    "52168": "Webhook Credentials request timed out",
    "52170": "Too many Webhook Credential requests",
    "52171": "Webhook Credentials request signature was not verified",
    "52172": "Unexpected Binding Type used for Webhook Credentials request",
    "52173": "Unexpected Identifier used for Webhook Credentials request",
    "52174": "Unexpected error response received for Webhook Credentials request",
    "52181": "Too many SMS notification requests",
    "52182": "Messaging Service not specified",
    "52201": "Too many Facebook messenger notification requests",
    "52202": "Facebook page is not connected to Twilio",
    "52203": "Missing body for Facebook Messenger delivery attempt",
    "52211": "Too many Alexa notifications",
    "52212": "Missing Alexa skill ID",
    "52213": "Invalid Alexa user ID",
    "52214": "Alexa skill is not connected to Twilio",
    "52215": "Missing Title parameter for Alexa",
    "52301": "Resulted destination list for requested parameters is empty",
    "52302": "Too many recipients",
    "52303": "Concurrent User update",
    "52304": "User already exists",
    "52305": "User already belongs to the segment",
    "52306": "Cannot delete User resource with Bindings",
    "52307": "No users with provided segments",
    "52309": "Channel provider replied with an error",
    "52310": "Notification TTL has expired",
    "52311": "Delivery callback invocation failed",
    "52400": "Exceeded maximum iterations in template rendering",
    "52401": "Too many notification log events ",
    "52402": "General rendering problem with variables in a parsed template",
    "52403": "Provided text template in the notification request cannot be parsed",
    "52404": "Undefined variable within the notification payload template",
    "53000": "Signaling connection error",
    "53001": "Signaling connection disconnected",
    "53002": "Signaling connection timed out",
    "53003": "Client received an invalid signaling message",
    "53004": "Client sent an invalid signaling message",
    "53006": "Video server is busy",
    "53100": "Room name is invalid",
    "53101": "Room name is too long",
    "53102": "Room name contains invalid characters",
    "53103": " Unable to create Room",
    "53104": "Unable to connect to Room",
    "53105": "Room contains too many Participants",
    "53106": "Room not found",
    "53107": "MaxParticipants is out of range",
    "53108": "RoomType is not valid",
    "53109": "Timeout is out of range",
    "53110": "StatusCallbackMethod is invalid",
    "53111": "StatusCallback is invalid",
    "53112": "Status is invalid",
    "53113": "Room creation failed",
    "53118": "Room Completed Error",
    "53119": "The concurrent Rooms quota was exceeded",
    "53120": " Invalid Recording Rule(s)",
    "53121": "Approaching room or participant concurrency quota",
    "53122": "The recording operation requested is not supported for the Room type",
    "53123": "MaxParticipantDuration is out of range",
    "53124": "The AudioOnly flag is not supported for the Room type",
    "53125": "The track kind is not supported by the Room",
    "53126": "Legacy room type no longer supported",
    "53127": "audioOnly no longer supported",
    "53200": "Participant identity is invalid",
    "53201": "Participant identity is too long",
    "53202": "Participant identity contains invalid characters",
    "53203": "The maximum number of published tracks allowed in the Room at the same time has been reached",
    "53204": "Participant not found",
    "53205": "Participant disconnected because of duplicate identity",
    "53206": "The Participant concurrency quota was exceeded",
    "53207": "MaxPublishedTracks is out of range",
    "53208": "Participant's bandwidth profile configuration is invalid",
    "53209": "Participant status is invalid",
    "53215": "Invalid Subscribe Rule(s)",
    "53216": "Participant session length exceeded",
    "53217": "maxAudioTracks or maxVideoTracks configuration is out of range",
    "53300": "Track is invalid",
    "53301": "Track name is invalid",
    "53302": "Track name is too long",
    "53303": "Track name contains invalid characters",
    "53304": "Track name is duplicated",
    "53400": "Client is unable to create or apply a local media description",
    "53401": "Server is unable to create or apply a local media description",
    "53402": "Client is unable to apply a remote media description",
    "53403": "Server is unable to apply a remote media description",
    "53404": "No supported codec",
    "53405": "Media connection failed or Media activity ceased",
    "53406": "The data channel used by the Data Track had a problem",
    "53407": "Media connection failed due to DTLS handshake failure",
    "53408": "ICE connection restart was attempted, but it is not allowed",
    "53500": "Unable to acquire configuration",
    "53501": "Unable to acquire TURN credentials",
    "53600": "S3 URL for recording upload is invalid",
    "53601": "AWS credentials for recording upload are invalid",
    "53602": "AWS encryption key for recording upload is invalid",
    "53603": "Internal failure while processing a recording",
    "53604": "Failed to upload the recording to S3",
    "53605": "Internal failure when retrieving your account's recording settings",
    "53606": "Internal failure when creating the recording resource",
    "53607": "Internal failure when updating the recording resource",
    "53610": "Invalid URL for external S3 bucket in recording settings",
    "53611": "Invalid AWS credentials to access external S3 bucket in recording settings",
    "53612": "Invalid public key for media tracks encryption in recording settings",
    "53613": "AWS credentials to access external S3 bucket could not be loaded",
    "53614": "Public key credentials for media tracks encryption could not be loaded",
    "53615": "Access denied to external S3 bucket configured in recording settings",
    "53616": "Deleted a recording with custom configuration as time for retries was depleted",
    "53617": "Internal failure when bulk deleting compositions from your account",
    "53620": "Invalid URL for external S3 bucket in composition settings",
    "53621": "Invalid AWS credentials to access external S3 bucket in composition settings",
    "53622": "Invalid public key for media tracks encryption in composition settings",
    "53623": "AWS credentials to access external S3 bucket could not be loaded",
    "53624": "Public key credentials for media tracks encryption could not be loaded",
    "53625": "Access denied to external S3 bucket configured in composition settings",
    "53626": "Internal failure while processing media composition",
    "53627": "Internal failure when updating the composition resource",
    "53628": "Room recordings deleted",
    "53630": "Empty track list for composition",
    "53631": "Failed to enqueue a room composition from a configured composition hook",
    "53632": "Failed to enqueue a room composition",
    "53633": "Composition is too large",
    "53660": "Status Callback response timed out",
    "53661": "StatusCallbackMethod is invalid",
    "53662": "StatusCallback is invalid",
    "53663": "Internal failure when bulk deleting recordings from your account",
    "53664": "Invalid URL for external S3 bucket in composition settings",
    "53665": "Invalid AWS credentials to access external S3 bucket in composition settings",
    "53666": "Invalid public key for media tracks encryption in composition settings",
    "53667": "AWS credentials to access external S3 bucket could not be loaded",
    "53668": "Public key credentials for media tracks encryption could not be loaded",
    "53669": "Access denied to external S3 bucket configured in composition settings",
    "54003": "Invalid If-Match header",
    "54006": "Request entity too large",
    "54007": "Access forbidden for identity",
    "54008": "Invalid JSON",
    "54009": "Rate limit exceeded",
    "54010": "No parameters specified",
    "54011": "Invalid TTL",
    "54050": "Service Instance not found",
    "54051": "Invalid webhook URL",
    "54053": "Invalid friendly name",
    "54056": "Account cannot access requested Service Instance",
    "54100": "Document not found",
    "54101": "Invalid Document data",
    "54103": "Document revision mismatch",
    "54150": "List not found",
    "54151": "List Item not found",
    "54155": "List Item revision mismatch",
    "54156": "Invalid List Item data",
    "54200": "Map not found",
    "54201": "Map Item not found",
    "54205": "Map Item revision mismatch",
    "54206": "Invalid Map Item data",
    "54208": "Map Item already exists",
    "54209": "Invalid Map Item key",
    "54250": "Message Stream not found",
    "54251": "Invalid Message Stream Message data",
    "54300": "Unique name not found",
    "54301": "Unique name already exists",
    "54302": "Invalid unique name",
    "54351": "Invalid identity",
    "54354": "Permission not found",
    "54419": "Number of subscriptions per connection is over the limit",
    "54450": "Invalid 'Direction' query parameter",
    "54451": "Invalid 'Order' query parameter",
    "54452": "Invalid 'Bounds' query parameter",
    "54453": "Invalid 'PageToken' query parameter",
    "54454": "Sync: Invalid 'PageSize' query parameter",
    "54458": "Invalid List Item index",
    "54502": "Invalid index name",
    "54507": "Invalid query",
    "54509": "Query expression contains too many operators",
    "54510": "Query expression contains an array with too many items",
    "55555": "Invalid Instruction passed to TaskRouter",
    "57001": "'Secret id' is empty",
    "57002": "'Secret id' is too long",
    "57003": "'Secret id' is invalid for this Partner",
    "57004": "'Category' is empty",
    "57005": "'Category' is too long",
    "57006": "'EventType' is empty",
    "57007": "'EventType' is absent",
    "57008": "'EventType' format must be String",
    "57009": "'EventType' is too long",
    "57010": "'PartnerName' is absent",
    "57011": "Unsupported Partner name",
    "57012": "Signature invalid",
    "57013": "'Topic' is absent",
    "57014": "'Event' data in payload is absent",
    "57016": "'Topic' is empty",
    "57017": "'Topic' is too long",
    "57018": "'Event' value type must be Map",
    "57019": "'Authorization' header is missing or is invalid",
    "57020": "Authorization failed",
    "57021": "Token invalid",
    "57022": "Required header is missing or invalid",
    "60001": "Downstream Authentication Failed",
    "60002": "End User Identification Timeout",
    "60003": "End User Data is Not Available",
    "60004": "Invalid Configuration ",
    "60005": "Downstream Carrier Error",
    "60006": "Invalid Phone Number",
    "60007": "Downstream Verification Failed",
    "60008": "Unsupported Carrier",
    "60200": "Invalid parameter",
    "60201": "Selected template translation is not approved",
    "60202": "Max check attempts reached",
    "60203": "Max send attempts reached.",
    "60204": "Service does not support this feature",
    "60205": "SMS is not supported by landline phone number",
    "60206": "'Amount' & 'Payee' params are required",
    "60207": "Max rate limits per service reached ",
    "60208": "Rate limit with that UniqueName already exists",
    "60209": "UniqueName format is invalid",
    "60210": "Max Buckets per Rate limit reached",
    "60211": "Bucket with the given Interval already exists",
    "60212": "Too many concurrent requests for phone number",
    "60213": "A Messaging Configuration already exists for the given country",
    "60214": "Call channel is not supported when using PSD2",
    "60215": "Max number of mailers per account reached",
    "60217": "Invalid Service configuration",
    "60218": "SendGrid Template is not active",
    "60219": "SendGrid Template does not contain required placeholders",
    "60220": "Messages to China require use case vetting",
    "60221": "No target verification specified",
    "60222": "SendGrid The from address does not match a verified Sender Identity",
    "60223": "Delivery channel disabled",
    "60224": "Missing substitutions for selected template",
    "60225": "Translation already exists for the provided template",
    "60226": "Messages sent to china require friendly_name",
    "60227": "The selected channel for template is not supported",
    "60228": "Template was not found",
    "60229": "Template translation was not found",
    "60231": "Sender id already exists for account",
    "60232": "Sender id does not exist",
    "60233": "Default sender id can't be deleted",
    "60234": "Sender id can not be set as not default",
    "60235": "Sender Definitions does not match with requirements",
    "60236": "The domain could not be obtained from the given email",
    "60237": "The given domain is on a deny list",
    "60238": "Verification Creation Attempt blocked by Twilio",
    "60239": "BYOT feature is not enabled",
    "60240": "Templates not allowed",
    "60241": "Static message required",
    "60242": "WhatsApp template not found",
    "60243": "Custom messages are not supported",
    "60244": "Custom messages are not supported",
    "60245": "You have exceeded your messaging limits",
    "60246": "Service already exists",
    "60247": "Message Length Exceeded",
    "60300": "Invalid Param",
    "60301": "Entity already exists",
    "60302": "FactorType already exists",
    "60305": "Access Token parameters are invalid",
    "60306": "Invalid Request",
    "60307": "Cannot resend push notifications to 'none' notification platform",
    "60308": "Challenge verification attempts limit reached",
    "60309": "Push notifications limit reached for a Challenge",
    "60310": "Factor verification attempts reached",
    "60311": "Factor verification failed",
    "60312": "Challenge creation limit reached",
    "60313": "Unauthorized factor creation",
    "60314": "Factors binding format is invalid",
    "60315": "Reached max limit of 20 push Factors associated per Entity",
    "60317": "Factor already exists",
    "60318": "Factor is unverified",
    "60322": "Challenge already responded",
    "60323": "Challenge expired",
    "60324": "Challenge verification failed",
    "60325": "Translation for locale not found, using default",
    "60326": "Too many requests to create factors for the entity",
    "60327": "The provided channel is not supported by the given template. Verify is falling back to the static message.",
    "60328": "Entities rate limit exceeded",
    "60329": "Verify SNA does not work with `psd2_enabled`",
    "60330": "Failed to invoke the webhook",
    "60331": "Locale requested is not supported by Verify Text-To-Speech conversion",
    "60333": "The SMS message was sent using a brandless template.",
    "60334": "The SMS message was sent using a brandful template.",
    "60361": "Account SID is invalid or not provided",
    "60362": "Factor SID invalid or not provided",
    "60363": "Service SID invalid or not provided",
    "60364": "Challenge SID invalid or not provided",
    "60365": "Entity SID invalid or not provided",
    "60366": "Entity invalid or not provided",
    "60367": "Invalid entity identity",
    "60368": "Challenge details invalid or not provided",
    "60369": "Factor type invalid or not provided",
    "60370": "Factor config invalid or not provided",
    "60371": "Relying party invalid or not provided",
    "60372": "Relying party id invalid or not provided",
    "60373": "Invalid page size",
    "60374": "Invalid page token",
    "60375": "Invalid id",
    "60376": "Invalid rawId",
    "60377": "Authenticator attachment invalid or not provided",
    "60378": "Authenticator response invalid or not provided",
    "60379": "Authenticator data invalid or not provided",
    "60380": "Client data invalid or not provided",
    "60381": "Signature invalid or not provided",
    "60382": "Factor does not match the relying party of the challenge",
    "60383": "Illegal factor status",
    "60384": "Invalid challenge timeout",
    "60385": "Public key invalid or not provided",
    "60386": "Attestation object invalid or not provided",
    "60387": "Attested credential data invalid or not provided",
    "60388": "User display name not provided",
    "60390": "Factor not found",
    "60391": "Challenge not found",
    "60392": "Entity not found",
    "60401": "Network Error",
    "60402": "Mapper Error",
    "60403": "Storage Error",
    "60404": "Input Error",
    "60405": "Key Storage Error",
    "60406": "Initialization Error",
    "60407": "Authentication Token Error",
    "60408": "TemplateSid is only supported for the SMS channel",
    "60409": "Custom message did not match any template",
    "60410": "Verification delivery attempt blocked",
    "60411": "Phone Number already exists",
    "60420": "Invalid Contact ID format",
    "60421": "Unexpected result when creating contact",
    "60422": "Contact not found",
    "60423": "Multiple contacts were found",
    "60424": "Contact address not found",
    "60425": "Verification SID invalid or not provided",
    "60426": "Verification ID invalid or not provided",
    "60427": "Factor ID invalid or not provided",
    "60428": "Unsupported channel",
    "60431": "Verification not found",
    "60432": "Unsupported passkeys relying party",
    "60433": "Unsupported passkeys approval content type",
    "60434": "Unsupported passkeys verification content type",
    "60436": "Recipient invalid or not provided",
    "60437": "Recipient type unsupported",
    "60440": "Unsupported verification content type",
    "60441": "Illegal status",
    "60500": "SNA Phone Number Mismatch",
    "60510": "SNA Error",
    "60511": "SNA Downstream Error",
    "60517": "SNA User-Agent Mismatch Error",
    "60519": "SNA Verification Result Pending",
    "60520": "SNA URL Failed",
    "60531": "SNA Carrier Not Detected",
    "60532": "SNA Potential Dual SIM Detected",
    "60533": "SNA Carrier Header Error",
    "60534": "SNA Downstream Carrier Error",
    "60540": "SNA Carrier Identified Invalid Phone Number",
    "60550": "Auto Channel Failed: None of the available channels could be selected due to validation errors. Check your debugger messages in console.",
    "60600": "Unprovisioned or out of coverage",
    "60601": "Authorization required for Canada lookups",
    "60602": "App hash can only be used with SMS channel",
    "60603": "SendGrid maximum credits exceeded",
    "60604": "SendGrid Authenticated user is not authorized to send mail",
    "60605": "Verification delivery attempt blocked",
    "60606": "Lookup Package is Not Enabled",
    "60607": "Lookup Unsupported Country",
    "60608": "Lookup Error",
    "60609": "Live activity not enabled",
    "60610": "Phone number outside of coverage",
    "60611": "Lookup Package Quota Reached",
    "60612": "Requested phone number not mobile",
    "60613": "Lookup Provider Degradation",
    "60614": "Lookup Request Must Be Completed in Different Twilio Region",
    "60616": "Lookup rate limit exceeded",
    "60617": "Lookup Not Enough Request Parameters",
    "60618": "Lookup Malformed Request Parameter",
    "60619": "Lookup Request Cannot be Completed in Twilio Region",
    "60620": "Lookup SIM Swap Information is Incomplete From Carrier",
    "60621": "Lookup Carrier Information Not Available",
    "60622": "Invalid Magic Number",
    "60623": "Verification Not Found",
    "60624": "Maximum rate limit for Trial Accounts",
    "60699": "Lookup Usage Disabled",
    "60700": "Something went wrong. Try again later",
    "60701": "Invalid request",
    "60702": "Business Profile not found",
    "60703": "Invalid phone numbers format",
    "60704": "Phone number not branded by Twilio",
    "60706": "Invalid Push Token",
    "60707": "Branded Channel not found",
    "60708": "Phone record number not found",
    "60709": "Business Profile already exists",
    "60710": "Phone number CPS not found",
    "60711": "Business status does not allow updates",
    "60712": "Error communicating with Regulatory Compliance API",
    "60713": "Error communicating with Regulatory Identification API",
    "60714": "Brand not found",
    "60715": "Error reading logo file",
    "60716": "Selected logo is not a valid PNG file",
    "60717": "Error uploading logo to the storage",
    "60719": "Branded Call not found",
    "60721": "Phone Number(s) already used in a Branded Channel",
    "60722": "Business status does not allow dismissal",
    "60723": "Brand status does not allow updates",
    "60724": "Brand status does not allow dismissal",
    "60725": "Brand status does not allow to have branded channels",
    "60726": "Business status does not allow to have brands",
    "60727": "Channel not found",
    "60728": "Account exceeded the hourly messages limit",
    "61000": "Add-ons: Internal server error",
    "61001": "Add-ons: Request timed out",
    "61002": "Add-ons: Provider could not complete request",
    "61003": "Add-ons: Requirements to invoke AddOns have not been met",
    "61004": "Add-ons: No results",
    "61005": "Add-ons: Bad request",
    "61006": "Add-ons: Add-ons unavailable for GET callbacks",
    "61007": "Add-ons: Response body too large",
    "61008": "Add-ons:  HTTP too many redirects",
    "61009": "Add-ons: Could not fulfill request with available data",
    "62000": "Failed to write to the database.",
    "62001": "Invalid SID",
    "62002": "Exchange not found",
    "62003": "MPLS carrier not found.",
    "62004": "Direct connect not found.",
    "62005": " Bandwidth reserve not found.",
    "62006": " MPLS carrier is not associated with the exchange.",
    "62007": "Direct connect is not associated with the exchange.",
    "62008": "Bandwidth reserve is not associated with the exchange.",
    "62009": "Account SID was not found.",
    "62010": "No authentication was provided.",
    "62011": "Unauthorized",
    "62012": "Connection not found.",
    "62013": "Unable to identify account owner of connection.",
    "62014": "Connection not ready",
    "62015": "Connection in transition",
    "62016": "Connection not active",
    "62017": "No IP route specified",
    "62018": "Invalid IP route",
    "62019": "IP route exceeds permitted IP range",
    "62020": "Connection pending deletion.",
    "62021": "IP Gateway Invalid",
    "62022": "Missing account SID",
    "62023": "Missing exchange",
    "62024": "Missing connection type",
    "62025": "Interconnect: Invalid connection type",
    "62026": "Interconnect: Missing MPLS carrier SID",
    "62027": "Interconnect: Extra MPLS parameter",
    "62028": "Interconnect: Connection expired.",
    "62034": "Interconnect: No useful parameters provided.",
    "62035": "Interconnect: No bandwidth was specified in the request",
    "62052": "Interconnect: This account is not a subaccount of the Interconnect Connection owner's account.",
    "62053": "Interconnect: The subaccount is not authorized to access this connection.  ",
    "62100": "IP address(es) already linked to another connection",
    "62200": "Provisioning failure - Network-API is unavailable!",
    "62220": "Provisioning failure - Requested bandwidth not available on the network device.",
    "63001": "Channel could not authenticate the request. Please see Channel specific error message for more information",
    "63002": "Channel could not find the From address",
    "63003": "Channel could not find To address",
    "63005": "Channel did not accept given content. Please see Channel specific error message for more information",
    "63006": "Could not format given content for the channel. Please see Channel specific error message for more information",
    "63007": "Twilio could not find a Channel with the specified 'From' address",
    "63008": "Could not execute the request because the channel module has been misconfigured. Please check the Channel configuration in Twilio",
    "63009": "Channel provider returned an internal service error (HTTP 5xx). Please see Channel specific error message for more information",
    "63010": "Twilio's platform encountered an internal error processing this message",
    "63011": "Invalid Request: Twilio encountered an error while processing your request",
    "63012": "Channel provider returned an internal service error",
    "63013": "Channel policy violation",
    "63014": "Channel message blocked by user action",
    "63015": "Channel Sandbox can only send messages to phone numbers that have joined the Sandbox",
    "63016": "Failed to send freeform message because you are outside the allowed window. If you are using WhatsApp, please use a Message Template.",
    "63017": "Rate limit exceeded",
    "63018": "Rate limit exceeded for Channel",
    "63019": "Media failed to download",
    "63020": "Twilio encountered a Business Manager account error",
    "63021": "Channel invalid content error",
    "63022": "Invalid vname certificate",
    "63023": "Channel generic error",
    "63024": "Invalid message recipient",
    "63025": "Media already exists",
    "63026": "Channel sender content flagged as spam",
    "63027": "Template does not exist for a language and locale",
    "63028": "Number of parameters provided does not match the expected number of parameters",
    "63029": "The receiver failed to download the template",
    "63030": "Unsupported parameter for type of channels message",
    "63031": "Channels message cannot have same 'From' and 'To'",
    "63032": "We cannot send this message to this user because of a WhatsApp limitation. ",
    "63033": "Recipient opted out to receive message",
    "63034": "Media exceeds size limit",
    "63035": "This operation is blocked because the RCS agent has not launched, the recipient has not accepted the invitation to become a tester, or the RCS sender only works in certain regions.",
    "63036": "The specified phone number cannot be reached using RCS at this time.",
    "63037": "Channel Media Upload Error",
    "63038": "Account exceeded the daily messages limit",
    "63039": "Warning! Facebook says your page is engaging in behavior that may be considered bothersome or abusive by users. To avoid messaging restrictions being placed on your Page, Facebook requires you to immediately decrease the rate at which you are sending messages outside the 24-hour window to this person.",
    "63040": "Template Rejected",
    "63041": "Template paused",
    "63042": "Template disabled",
    "63043": "Link to a sample media file returns 403 Forbidden",
    "63044": "Link to a sample media file returns 404 Not Found",
    "63045": "Link to a sample media file returned an unexpected error status",
    "63046": "Template approved",
    "63047": "Link to a sample media file returned an invalid Content-Type",
    "63049": "Meta chose not to deliver this WhatsApp marketing message",
    "63051": "WhatsApp Business Account is Locked",
    "63052": "Legacy WhatsApp Template Used",
    "63100": "Validation Error",
    "63101": "WABA ID provided is not valid or unable to be used",
    "63102": "Account already linked to another WABA ID",
    "63103": "Cannot assign payment method to WABA provided",
    "63104": "Maximum number of phone numbers reached for your WABA",
    "63105": "Channel does not support this action",
    "63106": "phone_number is not a RCS capable number",
    "63107": "phone_number must be a valid E.164 formatted phone number",
    "63108": "Sender is not ready to add test device",
    "63109": "This Sender has been migrated into a different account",
    "63110": "The phone number is already registered on WhatsApp",
    "63111": "Sender's phone number or WABA returned \"not found\"",
    "63112": "The Meta and/or WhatsApp Business Accounts connected to this Sender were disabled by Meta",
    "63113": "Sender Cannot Be Verified",
    "63114": "Too Many Verification Codes",
    "64001": "Pay: Configuration Error",
    "64002": "Pay: Service unavailable.",
    "64003": "Pay: Invalid charge amount.",
    "64004": "Pay: Invalid paymentConnector attribute in TwiML.",
    "64005": "Pay: Connector does not support tokenization.",
    "64006": "Pay: Connector does not support token type.",
    "64007": "Pay: Connector does not support creating charge.",
    "64008": "Pay: Payment Gateway rejected charge creation.",
    "64009": "Pay: Twilio is no longer authorized to initiate transactions on your behalf.",
    "64010": "Pay: Payment Gateway rejected token creation.",
    "64011": "Pay: Connector does not support the requested currency.",
    "64012": "Pay: Payment Gateway rejected the card.",
    "64013": "Pay: Connector does not support supplied paymentMethod attribute.",
    "64014": "Pay: ECP/ACH requires AVSName Parameter in the <Pay> verb.",
    "64015": "Pay: `<Pay>` verb is missing a needed Parameter",
    "64016": "Pay: Invalid Action URL",
    "64017": "Pay: BankAccountType Parameter not supported with PaymentMethod = \"credit-card\"",
    "64018": "Pay: Value needed for either Capture or Status parameters",
    "64019": "Pay: Required payment information incomplete",
    "64020": "Pay: Invalid Parameter Value",
    "64021": "Pay: Invalid Operation",
    "64022": "Pay: Invalid Test Card Number",
    "64023": "Pay: Invalid Test Bank Account Number",
    "64024": "Pay: Connector Instance Not Approved",
    "64101": "ConversationRelay: Invalid Parameter",
    "64102": "ConversationRelay: Unable to Connect to Websocket URL",
    "64103": "ConversationRelay: Internal Server Error",
    "64104": "ConversationRelay: Max call duration reached",
    "64105": "ConversationRelay: Websocket ended",
    "64106": "ConversationRelay: Invalid argument",
    "64107": "ConversationRelay: Invalid Message Received",
    "64108": "ConversationRelay: RTP Timeout",
    "64109": "ConversationRelay: Concurrency limit reached",
    "64110": "ConversationRelay: Account has been opted out",
    "68001": "Network Error",
    "68002": "Mapper Error",
    "68003": "Storage Error",
    "68004": "Input Error",
    "68005": "Key Storage Error",
    "68006": "Initialization Error",
    "68007": "Authentication Token Error",
    "70001": "Validation Failed",
    "70002": "Bad request",
    "70003": "Outdated Entity",
    "70004": "Unauthorized",
    "70005": "Failure Threshold Exceeded",
    "70051": "Authorization Failed",
    "70052": "Public Key Client Validation Required For Account",
    "70053": "Public Key Client Validation Not Enabled For Account",
    "70101": "Unsupported Public Key Algorithm",
    "70102": "Unsupported Public Key Length",
    "70103": "Unsupported Public Key Exponent",
    "70104": "Invalid Public Key",
    "70105": "Invalid Type Specified in the Request",
    "70106": "Invalid AWS credentials",
    "70151": "Maximum Number Of API Keys Exceeded",
    "70152": "Request Contains Invalid Flags",
    "70153": "Public Key Specified Does Not Exist",
    "70154": "Public Key Is Invalid",
    "70155": "Request Is Missing Required HTTP Headers",
    "70156": "Request Hash Is Invalid",
    "70251": "Bad SSO Settings",
    "70252": "Bad Saml Response",
    "70253": "Invalid User Grants",
    "80101": "Number Already Added to Another Service",
    "80102": "Participant Already In Interaction",
    "80103": "Participant Already In Session",
    "80104": "Phone Number Already In Service",
    "80105": "Short Code Already In Service",
    "80201": "No Available Voice Proxy",
    "80202": "No Available Message Proxy",
    "80203": "No Available Proxy For Country",
    "80205": "No Proxies For Service",
    "80206": "No Available Proxy",
    "80207": " No unreserved numbers in proxy pool.",
    "80208": "No Available Unused Proxy",
    "80301": "Not Found Phone Number SID",
    "80303": "Not Found Short Code Sid",
    "80304": "Not Found Unmanaged Identifier",
    "80305": "Not Found Unmanaged Identifier Sid",
    "80306": "Not Found Chat Service",
    "80307": "Record to be updated was not found in database.",
    "80308": "Session with the unique name not found.",
    "80401": "Account Sid Invalid",
    "80402": "Identifier Proxy Pair Invalid",
    "80403": "Interaction Sid Invalid",
    "80404": "Participant Identifier Invalid",
    "80405": "Participant Sid Invalid",
    "80406": "Phone Number Did Invalid",
    "80407": "Phone Number Sid Invalid",
    "80408": "Service Sid Invalid",
    "80409": "Session Sid Invalid",
    "80501": "Storage Operation Failed",
    "80502": "Internal Server Error from Downstream",
    "80503": "No Records Updated",
    "80504": "An internal server error has occurred.",
    "80505": "Flex Configuration Error",
    "80506": "Service Creation is restricted for new customers",
    "80601": "Phone Number Not Available",
    "80602": "Non Unique Service Name",
    "80603": "Non Unique Session Name",
    "80604": "Proxy Identifier In Use",
    "80605": "Proxy Identifier Not In Service",
    "80606": "Proxy Identifier Not Owned By Account",
    "80607": "Session Closed",
    "80608": "Session Status Invalid",
    "80609": "Too Many Added Participants",
    "80610": "Unauthorized Operation",
    "80611": "Proxy Number In Active Sessions",
    "80612": "Duplicate Entry",
    "80613": "Downstream Request Rejected",
    "80614": " No Partner Participant Found",
    "80615": "Account Sid on Legal Hold",
    "80616": "Unsupported Identifier Type For Session Mode",
    "80617": "Flex Configuration Error",
    "80618": "Chat Integration Error",
    "80619": "Chat Channel Attribute Error",
    "80620": "Chat Configured Proxy Identifier Not Found",
    "80621": "Requests Rate Limited on Endpoint",
    "80622": "Maximum Pool Size Error",
    "80623": "Duplicate Participant Request",
    "80624": "Approaching Maximium Number Pool Size",
    "80625": "Unauthorized Request. Signature is missing or is invalid",
    "80701": "Parameter Validation Failed",
    "80801": "Invalid attempt to Re-Open a Session",
    "80802": "Simultaneous requests to create the same Identifier in one or more Sessions",
    "80901": "Message Matched Stop Word",
    "80902": "No Active Session",
    "80903": "Unknown Participant",
    "80904": "Expired Proxy Session",
    "80905": "Unknown Scenario",
    "80906": "Interaction Not Open",
    "80907": "Open Interaction Not Found",
    "80908": "Callback Error",
    "80909": "Inbound Contact Rejected",
    "80910": "Message To Voice Only Session Rejected",
    "80911": "Call To Message Only Session Rejected",
    "80913": "Out-Of-Session Callback Error",
    "81000": "The Execution has exceeded max steps allowed for a flow",
    "81001": "The Widget has exceeded max steps in a loop",
    "81002": "Unexpected event while processing Widget",
    "81004": "Failed to add member to Chat Channel",
    "81005": "Failed to transition because no match was found",
    "81006": "Failed to create Chat Channel",
    "81007": "Connecting to a Call timed out",
    "81008": "Failed to connect to outgoing Call",
    "81009": "Timed out enqueueing Call",
    "81010": "There was an internal error while processing a Function",
    "81011": "Failed to send Message",
    "81012": "Failed to update Sync service",
    "81013": "Failed to invoke Understand API",
    "81014": "There was an internal error while processing an HTTP request",
    "81015": "Failed to Create Task",
    "81016": "Outbound HTTP Request Failed",
    "81017": "Error in Twilio Function Response",
    "81018": "Template evaluation error in Studio widget",
    "81019": "Twilio phone number using deprecated API version",
    "81020": "Unsupported Trigger Type",
    "81021": "Flow revision must be an integer or enum(LatestPublished, LatestRevision)",
    "81022": "Flow definition validation failed",
    "81023": "Creating an Execution via REST API failed due to malformed contact parameters",
    "81024": "Subflow Error",
    "81025": "Studio Flow exceeds maximum allowed widgets",
    "81026": "Studio Execution failed because Flow exceeds maximum allowed widgets",
    "81027": "Error parsing type in Studio widget",
    "82001": "Function invocation resulted in StatusCode 4xx",
    "82002": "Error on Twilio Function response",
    "82003": "Deployment Installation Failure",
    "82004": "Function execution resulted in a warning log",
    "82005": "Function execution resulted in an error log",
    "82006": "Environment Context too large",
    "82007": "Unsupported Runtime",
    "82008": "Headers or cookies too large",
    "82009": "Multi-valued headers not supported",
    "83000": "Super SIM registration failed due to Internal Error",
    "83001": "Parameter missing while registering a Super SIM",
    "83002": "Super SIM cannot be registered",
    "83003": "The Super SIM already belongs to the requesting Account.",
    "83004": "Super SIM update operation failed due to Internal Error",
    "83005": "Super SIM not found",
    "83006": "Super SIM’s Target Fleet not found",
    "83007": "Unable to activate your Super SIM as it does not belong to a Fleet",
    "83008": "Unable to remove your Super SIM from its Fleet",
    "83009": "Unable to update your Super SIM’s Fleet while it is in status scheduled",
    "83010": "Unable to update your Super SIM to the desired status",
    "83011": "A Super SIM with the specified Unique Name exists already",
    "83400": "IP Commands error",
    "83401": "The device was not attached to a cellular network",
    "83402": "Received error response to IP Command callback request",
    "83500": "No eSIM Profiles are available",
    "83600": " An invalid parameter value was passed to the API",
    "83601": "Request StartTime and/or EndTime must be aligned to UTC day boundaries",
    "83602": "Request StartTime and/or EndTime must be aligned to UTC hour boundaries.",
    "83603": "The maximum allowed query period is 31 days for group by sim queries",
    "83604": "The requested query period exceeds the maximum allowed period for the requested Granularity",
    "83605": "StartTime parameter is too far in the past. It must be within the last 18 months.",
    "83700": "Attachment Failed Due To Internal Error",
    "83701": "Data Session Establishment Failed Due To Internal Error",
    "83702": "Attachment Rejected Due To Network Not Allowed",
    "83703": "Attachment Rejected Due To Rate Limiting",
    "83704": "Attachment Rejected Due To SIM In New State",
    "83705": "Attachment Rejected Due To SIM In Inactive State",
    "84000": "Execution has exceeded max steps allowed for a flow.",
    "84001": "Workflow execution timed out.",
    "84002": "Workflow execution failed. ",
    "84003": "Unable to render block.",
    "84004": "Error while creating execution via REST API.",
    "90000": "Uncaught Flex JavaScript Exception",
    "90001": "Message SID is invalid",
    "90002": "Too Many Errors",
    "90003": "Unable to fetch plugins from the Custom Plugins URL",
    "90004": "Message Truncated",
    "90006": "Invalid direction",
    "90007": "Invalid validity period value",
    "90009": "The message SID already exists.",
    "90010": "Account is not active",
    "90011": "MessageSid is invalid",
    "90012": "'Recipients' list has too many items [deprecated] ",
    "90013": "'Template' or 'TemplateSid'&'TemplateLanguage' or 'MediaUrls' is required",
    "90014": "Validity Period should be positive integer",
    "90015": "Body and Template (Body, Sid, Language, Args) are provided",
    "90016": "'Template' or 'TemplateSid'/'TemplateLanguage' is required to send a Template Message",
    "90017": "'Template' and 'TemplateSid'/'TemplateLanguage' must not be specified together",
    "90018": "'Template' field is too long",
    "90019": "'TemplateArgs' dictionary size is too large",
    "90020": "One of 'TemplateArgs' dictionary key is blank",
    "90021": "One of 'TemplateArgs' dictionary key is too long",
    "90022": "One of 'TemplateArgs' dictionary value is too long",
    "90023": "One of 'TemplateArgs' dictionary value is null",
    "90024": "Template body has tag which is not provided in 'TemplateArgs'",
    "90025": "Template body has unsupported tag type",
    "90026": "Template body could not be parsed",
    "90027": "Broadcast 'FriendlyName' is too long",
    "90028": "Broadcast 'IdempotencyToken' is too long",
    "90029": "Broadcast 'CorrelationId' is empty",
    "90030": "Broadcast 'CorrelationId' is too long",
    "90031": "Broadcast Recipients list is empty [deprecated] ",
    "90032": "Broadcast recipient's 'to' is invalid",
    "90033": "Broadcast recipient's 'to' is too long",
    "90034": "'BroadcastStatusCallbackUrl' is too long",
    "90035": "Broadcast 'MessageStatusCallbackUrl' is too long",
    "90036": "Broadcast recipient's 'body' is too long",
    "90037": "Broadcast has too many 'CorrelationId' items",
    "90038": "'BroadcastStatusCallbackUrl' is invalid",
    "90039": "Broadcast 'MessageStatusCallbackUrl' is invalid",
    "90040": "Broadcast 'MediaUrls' list has too many items",
    "90041": "Broadcast 'MediaUrl' field is too long",
    "90100": "Invalid Autopilot Actions JSON",
    "90101": "Unique Name Already Exists",
    "90102": "Assistant failure to start collection",
    "90103": "Error processing answer during collection",
    "90104": "Invalid Collect Field Type",
    "90403": "[Autopilot] Signature validation failed",
    "91000": "Sink could not be created",
    "91001": "Sink could not be found",
    "91002": "Incorrect values for pagination",
    "91003": "Account reached the max sink limit",
    "91004": "Test event cannot be found",
    "91005": "Test ID is invalid",
    "91006": "The sink sid is in an invalid format",
    "91007": "Sink still in use",
    "91100": "Subscription could not be created",
    "91101": "Subscription could not be created",
    "91102": "Subscription could not be found",
    "91103": "Event type list is empty",
    "91104": "Event type not found",
    "91201": "Bad Request",
    "91202": "Not Found",
    "91203": "Method Not Allowed",
    "92001": "'Types' Parameter Required",
    "92002": "The 'variables' parameter exceeds the allowed limit",
    "92003": "'language' Parameter Required",
    "92004": "Invalid language code",
    "92005": "ContentSid Required",
    "92006": "The Content Sid is Invalid",
    "92007": "The Content Variables Parameter is invalid",
    "92008": "Unsupported Content Type",
    "92009": "The template associated with this SID has already been submitted for approval.",
    "93100": "Replay failed",
    "93101": "Unable to deliver events to sink",
    "93102": "There was an error with your AWS role",
    "93103": "There was an error with your Kinesis stream",
    "93104": "There is an issue with the Kinesis Stream Name or Region",
    "93105": "Consent has already been provided for this account and vendor",
    "94000": "Transcriptions: request to transcribe audio error",
    "94001": "Transcriptions: Invalid transcribe value",
    "94002": "Transcriptions: configuration not found",
    "94100": "Transcriptions: status callback response error",
    "94101": "Transcriptions: status callback response timed out",
    "94200": "Transcriptions Settings: Invalid encryptionEnabled value",
    "94201": "Transcriptions Settings: encryptionKeySid invalid or not found",
    "94300": "Transcriptions Configurations: Invalid callback configuration",
    "94301": "Transcriptions Configurations: UniqueName is required",
    "94302": "Transcriptions Configurations: UniqueName is invalid",
    "94303": "Transcriptions Configurations: Language is required",
    "94304": "Transcriptions Configurations: Language is invalid",
    "94400": "Transcriptions: transcription internal error",
    "94401": "Transcriptions: audio processing error",
    "94402": "Transcriptions: Encryption failed and transcription result files deleted",
    "94403": "Transcriptions: Invalid encryption credentials",
    "94500": "Transcriptions: sourceSid invalid",
    "94501": "Transcriptions: Status invalid",
    "94600": "Filter limit exceeded",
    "94601": "Date range is not valid",
    "94602": "Invalid FromDate",
    "94603": "Ttl is out of range",
    "94604": "Account Sid on Legal Hold.",
    "95005": "Invalid media url",
    "95006": "Media url is empty",
    "95100": "Failed to transcribe",
    "95102": "Transcript media processing error",
    "95103": "Media file reached maximum size",
    "95104": "Invalid media type",
    "95105": "Failed to download audio file",
    "95106": "Speech-to-Text engine error",
    "95108": "Failed to delete resource",
    "95109": "Media content is empty",
    "95110": "Failed to download media: file was not found",
    "95111": "Failed to download media file: unauthorized",
    "95112": "Invalid sample rate found on media",
    "95113": "Corrupted media provided",
    "95114": "Media duration is too long.",
    "95115": "Media has too many channels",
    "95116": "PCI Recordings are not supported",
    "95118": "Twilio Recordings with external storage are not supported",
    "95119": "Voice Intelligence does not support encrypted recordings",
    "95200": "Status callback response error",
    "95201": "Status callback response timed out",
    "95250": "AI/ML Features Addendum has not been accepted",
    "95300": "Voice Intelligence Service was not found",
    "95301": "Language code on the Transcription request does not match the Voice Intelligence Service language",
    "95302": "Voice Intelligence Error",
    "97001": "Unable to retrieve OAuth access token",
    "99001": "General Service Error",
    "99002": "Tool Execution Error",
    "99003": "Guardrails input check failed",
    "99004": "Guardrails response check failed",
    "99005": "Invalid or Unresolved External Tool Endpoint",
    "99006": "Tool input schema is invalid.",
    "180017": "Require domestic emergency address",
    "216602": "Content Type is not supported on this channel",
    "456001": "Approaching Flex Plugin creation limit",
    "456002": "Approaching Flex Plugin Version creation limit"
};